import React from "react";

export const CarteLiberteDesktop = () => {
  return (
    <div
      style={{
        WebkitBoxAlign: "stretch",
        alignItems: "stretch",
        backgroundImage:
          "linear-gradient(90deg, rgb(243, 243, 248) 50%, rgb(243, 243, 248) 50%)",
        width: "100%",
        boxSizing: "border-box",
        backgroundColor: "rgb(243, 243, 248)",
        minHeight: "100%",
      }}
      className="hidden lg:flex"
    >
      <div
        style={{
          maxWidth: "1440px",
          paddingLeft: "0px",
          paddingRight: "0px",
          boxSizing: "border-box",
          padding: "0px",
          width: "100%",
          marginLeft: "auto",
          marginRight: "auto",
          display: "block",
          height: "auto",
        }}
      >
        <div
          style={{
            boxSizing: "border-box",
            display: "flex",
            flexFlow: "row wrap",
            width: "100%",
            WebkitBoxPack: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              paddingLeft: "24px",
              paddingRight: "24px",
              backgroundColor: "rgb(243, 243, 248)",
              flexBasis: "100%",
              WebkitBoxFlex: 0,
              flexGrow: 0,
              maxWidth: "100%",
              boxSizing: "border-box",
              margin: "0px",
              flexDirection: "row",
            }}
          >
            <div
              data-test="breadcrumb"
              style={{
                padding: "0px 80px",
                fontSize: "16px",
                lineHeight: "22px",
                boxSizing: "border-box",
                margin: "24px 0px 0px",
                fontFamily: "Avenir",
                fontWeight: 500,
                color: "rgb(94, 104, 120)",
              }}
            >
              <ol
                style={{
                  boxSizing: "border-box",
                  display: "flex",
                  flexWrap: "wrap",
                  WebkitBoxAlign: "center",
                  alignItems: "center",
                  padding: "0px",
                  margin: "0px",
                  listStyle: "outside none none",
                }}
              >
                <li style={{ boxSizing: "border-box" }}>
                  <a
                    href="/app"
                    style={{
                      fontSize: "13px",
                      lineHeight: "18px",
                      boxSizing: "border-box",
                      backgroundColor: "rgba(0, 0, 0, 0)",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontWeight: 500,
                      color: "rgb(20, 112, 138)",
                      textDecoration: "none solid rgb(20, 112, 138)",
                      cursor: "pointer",
                      position: "relative",
                      WebkitBoxAlign: "center",
                      alignItems: "center",
                      display: "inline-flex",
                      padding: "0px",
                    }}
                  >
                    Accueil
                  </a>
                </li>
                <li
                  aria-hidden="true"
                  style={{
                    boxSizing: "border-box",
                    display: "flex",
                    userSelect: "none",
                    marginLeft: "8px",
                    marginRight: "8px",
                  }}
                >
                  <svg
                    aria-hidden="true"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{
                      boxSizing: "border-box",
                      height: "13px",
                      margin: "2px -8px 0px",
                      width: "1.25rem",
                    }}
                  >
                    <path
                      d="M8.79362 6.6659C8.36568 7.06175 8.36568 7.73825 8.79362 8.1341L12.973 12L8.79362 15.8659C8.36568 16.2617 8.36568 16.9383 8.79362 17.3341L8.83447 17.3719C9.21775 17.7264 9.80928 17.7264 10.1926 17.3719L15.2064 12.7341C15.6343 12.3383 15.6343 11.6617 15.2064 11.2659L10.1926 6.62811C9.80928 6.27358 9.21775 6.27358 8.83447 6.62811L8.79362 6.6659Z"
                      style={{ boxSizing: "border-box" }}
                    ></path>
                  </svg>
                </li>
                <li style={{ boxSizing: "border-box" }}>
                  <a
                    href="/app/offre"
                    style={{
                      fontSize: "13px",
                      lineHeight: "18px",
                      boxSizing: "border-box",
                      backgroundColor: "rgba(0, 0, 0, 0)",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontWeight: 500,
                      color: "rgb(20, 112, 138)",
                      textDecoration: "none solid rgb(20, 112, 138)",
                      cursor: "pointer",
                      position: "relative",
                      WebkitBoxAlign: "center",
                      alignItems: "center",
                      display: "inline-flex",
                      padding: "0px",
                    }}
                  >
                    Offres
                  </a>
                </li>
                <li
                  aria-hidden="true"
                  style={{
                    boxSizing: "border-box",
                    display: "flex",
                    userSelect: "none",
                    marginLeft: "8px",
                    marginRight: "8px",
                  }}
                >
                  <svg
                    aria-hidden="true"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{
                      boxSizing: "border-box",
                      height: "13px",
                      margin: "2px -8px 0px",
                      width: "1.25rem",
                    }}
                  >
                    <path
                      d="M8.79362 6.6659C8.36568 7.06175 8.36568 7.73825 8.79362 8.1341L12.973 12L8.79362 15.8659C8.36568 16.2617 8.36568 16.9383 8.79362 17.3341L8.83447 17.3719C9.21775 17.7264 9.80928 17.7264 10.1926 17.3719L15.2064 12.7341C15.6343 12.3383 15.6343 11.6617 15.2064 11.2659L10.1926 6.62811C9.80928 6.27358 9.21775 6.27358 8.83447 6.62811L8.79362 6.6659Z"
                      style={{ boxSizing: "border-box" }}
                    ></path>
                  </svg>
                </li>
                <li style={{ boxSizing: "border-box" }}>
                  <p
                    aria-current="page"
                    style={{
                      fontSize: "13px",
                      lineHeight: "18px",
                      boxSizing: "border-box",
                      margin: "2px 0px 0px",
                      fontFamily: "Avenir",
                      fontWeight: 500,
                      color: "rgb(12, 19, 31)",
                    }}
                  >
                    Carte Liberté
                  </p>
                </li>
              </ol>
            </div>
            <div
              style={{
                flexFlow: "row nowrap",
                marginTop: "40px",
                padding: "0px 80px 56px",
                boxSizing: "border-box",
                WebkitBoxAlign: "center",
                alignItems: "center",
                display: "flex",
                flexDirection: "row",
                paddingBottom: "56px",
              }}
            >
              <div
                style={{
                  marginRight: "160px",
                  boxSizing: "border-box",
                  alignSelf: "start",
                  display: "flex",
                  flexDirection: "column",
                  marginBottom: "32px",
                }}
              >
                <h2
                  style={{
                    fontSize: "24px",
                    lineHeight: "30px",
                    boxSizing: "border-box",
                    margin: "0px 0px 16px",
                    fontFamily: "Avenir",
                    fontWeight: 800,
                  }}
                >
                  Carte Liberté
                </h2>
                <p
                  style={{
                    maxWidth: "628px",
                    fontSize: "16px",
                    lineHeight: "22px",
                    boxSizing: "border-box",
                    margin: "0px",
                    fontFamily: "Avenir",
                    fontWeight: 500,
                    whiteSpace: "pre-line",
                  }}
                >
                  La Carte Liberté s'adresse à tous les voyageurs fréquents.
                </p>
              </div>
              <ul
                role="list"
                style={{
                  boxSizing: "border-box",
                  alignSelf: "start",
                  display: "flex",
                  flexDirection: "column",
                  listStyleType: "none",
                  margin: "0px",
                  padding: "0px",
                }}
              >
                <li
                  style={{
                    boxSizing: "border-box",
                    display: "flex",
                    flexFlow: "row nowrap",
                    marginBottom: "16px",
                  }}
                >
                  <div style={{ boxSizing: "border-box" }}>
                    <svg
                      aria-hidden="true"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                      data-test="majorAvantages-0"
                      style={{
                        boxSizing: "border-box",
                        fill: "rgb(12, 19, 31)",
                        marginRight: "16px",
                        height: "24px",
                        width: "24px",
                      }}
                    >
                      <path
                        d="M2.11377 19.4238C2.11373 19.3582 2.12664 19.2931 2.15175 19.2324C2.17687 19.1718 2.21369 19.1166 2.26013 19.0702C2.30657 19.0238 2.3617 18.9869 2.42238 18.9618C2.48306 18.9367 2.5481 18.9238 2.61377 18.9238H4.48486C5.53557 18.9234 6.5499 19.3086 7.33545 20.0063L7.51904 20.1694C8.12172 20.7048 8.89993 21.0003 9.70605 21H16.4829C16.7511 21 17.0083 20.8935 17.198 20.7038C17.3876 20.5142 17.4941 20.257 17.4941 19.9888C17.4941 19.7206 17.3876 19.4634 17.198 19.2737C17.0083 19.0841 16.7511 18.9775 16.4829 18.9775C16.3503 18.9775 16.2231 18.9249 16.1294 18.8311C16.0356 18.7373 15.9829 18.6101 15.9829 18.4775C15.9829 18.3449 16.0356 18.2178 16.1294 18.124C16.2231 18.0302 16.3503 17.9775 16.4829 17.9775H17.625C17.8933 17.9775 18.1505 17.871 18.3402 17.6813C18.5299 17.4916 18.6365 17.2343 18.6365 16.966C18.6365 16.6978 18.5299 16.4405 18.3402 16.2508C18.1505 16.0611 17.8933 15.9545 17.625 15.9545C17.4924 15.9545 17.3652 15.9019 17.2714 15.8081C17.1777 15.7143 17.125 15.5871 17.125 15.4545C17.125 15.3219 17.1777 15.1948 17.2714 15.101C17.3652 15.0072 17.4924 14.9545 17.625 14.9545C17.6759 14.9545 17.7238 14.9659 17.7737 14.9696C17.8074 14.9588 17.8422 14.9518 17.8774 14.9487H18.5703C18.8385 14.9487 19.0957 14.8421 19.2854 14.6525C19.475 14.4629 19.5815 14.2056 19.5815 13.9375C19.5815 13.6693 19.475 13.412 19.2854 13.2224C19.0957 13.0328 18.8385 12.9262 18.5703 12.9262C18.4377 12.9262 18.3105 12.8735 18.2168 12.7798C18.123 12.686 18.0703 12.5588 18.0703 12.4262C18.0703 12.2936 18.123 12.1664 18.2168 12.0727C18.3105 11.9789 18.4377 11.9262 18.5703 11.9262H19.875C20.1427 11.9254 20.3992 11.8184 20.5882 11.6288C20.7772 11.4392 20.8833 11.1825 20.8833 10.9147C20.8833 10.647 20.7772 10.3902 20.5882 10.2006C20.3992 10.011 20.1427 9.90411 19.875 9.90327H11.8501C11.7175 9.90327 11.5903 9.85059 11.4965 9.75682C11.4028 9.66306 11.3501 9.53588 11.3501 9.40327C11.3501 9.27066 11.4028 9.14349 11.4965 9.04972C11.5903 8.95595 11.7175 8.90327 11.8501 8.90327H12.4595L12.9727 4.41011C12.9588 4.03012 12.7976 3.67043 12.5232 3.40723C12.2488 3.14402 11.8827 2.99797 11.5024 3H10.3364C10.2973 3.00019 10.2593 3.01291 10.2279 3.03628C10.1966 3.05965 10.1735 3.09245 10.1621 3.12988L8.59131 8.35742C8.44535 8.85127 8.14303 9.2844 7.7298 9.5917C7.31657 9.899 6.81476 10.0639 6.2998 10.0615H3.26318C3.13057 10.0615 3.00339 10.0088 2.90963 9.91507C2.81586 9.82131 2.76318 9.69413 2.76318 9.56152C2.76318 9.42891 2.81586 9.30173 2.90963 9.20797C3.00339 9.1142 3.13057 9.06152 3.26318 9.06152H6.2998C6.59949 9.06295 6.89154 8.96703 7.13203 8.78818C7.37251 8.60934 7.54842 8.35725 7.6333 8.06982L9.2041 2.84229C9.27824 2.59943 9.42815 2.38667 9.63189 2.23512C9.83563 2.08357 10.0825 2.00118 10.3364 2H11.5024C12.1565 2.00069 12.7835 2.2608 13.246 2.72327C13.7084 3.18573 13.9685 3.81278 13.9692 4.4668L13.4653 8.90332H19.875C20.3735 8.90337 20.8542 9.08851 21.2239 9.42286C21.5937 9.75721 21.8261 10.2169 21.8761 10.7129C21.9261 11.2089 21.7902 11.7058 21.4946 12.1072C21.1991 12.5086 20.765 12.786 20.2766 12.8856C20.4346 13.1372 20.5343 13.4209 20.5684 13.716C20.6025 14.0111 20.5701 14.3101 20.4737 14.5911C20.3772 14.8721 20.2191 15.1279 20.0109 15.3398C19.8027 15.5518 19.5497 15.7144 19.2705 15.8159C19.4556 16.0779 19.5748 16.3807 19.618 16.6986C19.6613 17.0165 19.6273 17.3401 19.519 17.6421C19.4106 17.9441 19.2312 18.2155 18.9957 18.4335C18.7603 18.6514 18.4758 18.8094 18.1664 18.8941C18.365 19.1971 18.4778 19.5482 18.4929 19.9101C18.508 20.2721 18.4248 20.6313 18.2522 20.9498C18.0796 21.2683 17.824 21.5341 17.5124 21.719C17.2009 21.9039 16.8452 22.001 16.4829 22H9.70605C8.6552 22.0005 7.64073 21.6153 6.855 20.9175L6.67141 20.7544C6.06887 20.2191 5.29084 19.9236 4.48488 19.9238H2.61377C2.5481 19.9239 2.48306 19.911 2.42238 19.8858C2.3617 19.8607 2.30657 19.8239 2.26013 19.7775C2.21369 19.731 2.17687 19.6759 2.15175 19.6152C2.12664 19.5545 2.11373 19.4895 2.11377 19.4238Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                    </svg>
                  </div>
                  <p
                    aria-hidden="true"
                    style={{
                      maxWidth: "none",
                      fontSize: "20px",
                      lineHeight: "26px",
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontWeight: 800,
                    }}
                  >
                    Une seule carte pour tous vos déplacements : pros et perso
                  </p>
                  <span
                    style={{
                      fontSize: "16px",
                      lineHeight: "22px",
                      boxSizing: "border-box",
                      fontFamily: "Avenir",
                      fontWeight: 500,
                      border: "0px none rgb(12, 19, 31)",
                      clip: "rect(0px, 0px, 0px, 0px)",
                      height: "1px",
                      margin: "-1px",
                      overflow: "hidden",
                      padding: "0px",
                      position: "absolute",
                      whiteSpace: "nowrap",
                      width: "1px",
                    }}
                  >
                    Une seule carte pour tous vos déplacements : pros et perso
                  </span>
                </li>
                <li
                  style={{
                    boxSizing: "border-box",
                    display: "flex",
                    flexFlow: "row nowrap",
                    marginBottom: "16px",
                  }}
                >
                  <div style={{ boxSizing: "border-box" }}>
                    <svg
                      aria-hidden="true"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                      data-test="majorAvantages-1"
                      style={{
                        boxSizing: "border-box",
                        fill: "rgb(12, 19, 31)",
                        marginRight: "16px",
                        height: "24px",
                        width: "24px",
                      }}
                    >
                      <path
                        d="M2.11377 19.4238C2.11373 19.3582 2.12664 19.2931 2.15175 19.2324C2.17687 19.1718 2.21369 19.1166 2.26013 19.0702C2.30657 19.0238 2.3617 18.9869 2.42238 18.9618C2.48306 18.9367 2.5481 18.9238 2.61377 18.9238H4.48486C5.53557 18.9234 6.5499 19.3086 7.33545 20.0063L7.51904 20.1694C8.12172 20.7048 8.89993 21.0003 9.70605 21H16.4829C16.7511 21 17.0083 20.8935 17.198 20.7038C17.3876 20.5142 17.4941 20.257 17.4941 19.9888C17.4941 19.7206 17.3876 19.4634 17.198 19.2737C17.0083 19.0841 16.7511 18.9775 16.4829 18.9775C16.3503 18.9775 16.2231 18.9249 16.1294 18.8311C16.0356 18.7373 15.9829 18.6101 15.9829 18.4775C15.9829 18.3449 16.0356 18.2178 16.1294 18.124C16.2231 18.0302 16.3503 17.9775 16.4829 17.9775H17.625C17.8933 17.9775 18.1505 17.871 18.3402 17.6813C18.5299 17.4916 18.6365 17.2343 18.6365 16.966C18.6365 16.6978 18.5299 16.4405 18.3402 16.2508C18.1505 16.0611 17.8933 15.9545 17.625 15.9545C17.4924 15.9545 17.3652 15.9019 17.2714 15.8081C17.1777 15.7143 17.125 15.5871 17.125 15.4545C17.125 15.3219 17.1777 15.1948 17.2714 15.101C17.3652 15.0072 17.4924 14.9545 17.625 14.9545C17.6759 14.9545 17.7238 14.9659 17.7737 14.9696C17.8074 14.9588 17.8422 14.9518 17.8774 14.9487H18.5703C18.8385 14.9487 19.0957 14.8421 19.2854 14.6525C19.475 14.4629 19.5815 14.2056 19.5815 13.9375C19.5815 13.6693 19.475 13.412 19.2854 13.2224C19.0957 13.0328 18.8385 12.9262 18.5703 12.9262C18.4377 12.9262 18.3105 12.8735 18.2168 12.7798C18.123 12.686 18.0703 12.5588 18.0703 12.4262C18.0703 12.2936 18.123 12.1664 18.2168 12.0727C18.3105 11.9789 18.4377 11.9262 18.5703 11.9262H19.875C20.1427 11.9254 20.3992 11.8184 20.5882 11.6288C20.7772 11.4392 20.8833 11.1825 20.8833 10.9147C20.8833 10.647 20.7772 10.3902 20.5882 10.2006C20.3992 10.011 20.1427 9.90411 19.875 9.90327H11.8501C11.7175 9.90327 11.5903 9.85059 11.4965 9.75682C11.4028 9.66306 11.3501 9.53588 11.3501 9.40327C11.3501 9.27066 11.4028 9.14349 11.4965 9.04972C11.5903 8.95595 11.7175 8.90327 11.8501 8.90327H12.4595L12.9727 4.41011C12.9588 4.03012 12.7976 3.67043 12.5232 3.40723C12.2488 3.14402 11.8827 2.99797 11.5024 3H10.3364C10.2973 3.00019 10.2593 3.01291 10.2279 3.03628C10.1966 3.05965 10.1735 3.09245 10.1621 3.12988L8.59131 8.35742C8.44535 8.85127 8.14303 9.2844 7.7298 9.5917C7.31657 9.899 6.81476 10.0639 6.2998 10.0615H3.26318C3.13057 10.0615 3.00339 10.0088 2.90963 9.91507C2.81586 9.82131 2.76318 9.69413 2.76318 9.56152C2.76318 9.42891 2.81586 9.30173 2.90963 9.20797C3.00339 9.1142 3.13057 9.06152 3.26318 9.06152H6.2998C6.59949 9.06295 6.89154 8.96703 7.13203 8.78818C7.37251 8.60934 7.54842 8.35725 7.6333 8.06982L9.2041 2.84229C9.27824 2.59943 9.42815 2.38667 9.63189 2.23512C9.83563 2.08357 10.0825 2.00118 10.3364 2H11.5024C12.1565 2.00069 12.7835 2.2608 13.246 2.72327C13.7084 3.18573 13.9685 3.81278 13.9692 4.4668L13.4653 8.90332H19.875C20.3735 8.90337 20.8542 9.08851 21.2239 9.42286C21.5937 9.75721 21.8261 10.2169 21.8761 10.7129C21.9261 11.2089 21.7902 11.7058 21.4946 12.1072C21.1991 12.5086 20.765 12.786 20.2766 12.8856C20.4346 13.1372 20.5343 13.4209 20.5684 13.716C20.6025 14.0111 20.5701 14.3101 20.4737 14.5911C20.3772 14.8721 20.2191 15.1279 20.0109 15.3398C19.8027 15.5518 19.5497 15.7144 19.2705 15.8159C19.4556 16.0779 19.5748 16.3807 19.618 16.6986C19.6613 17.0165 19.6273 17.3401 19.519 17.6421C19.4106 17.9441 19.2312 18.2155 18.9957 18.4335C18.7603 18.6514 18.4758 18.8094 18.1664 18.8941C18.365 19.1971 18.4778 19.5482 18.4929 19.9101C18.508 20.2721 18.4248 20.6313 18.2522 20.9498C18.0796 21.2683 17.824 21.5341 17.5124 21.719C17.2009 21.9039 16.8452 22.001 16.4829 22H9.70605C8.6552 22.0005 7.64073 21.6153 6.855 20.9175L6.67141 20.7544C6.06887 20.2191 5.29084 19.9236 4.48488 19.9238H2.61377C2.5481 19.9239 2.48306 19.911 2.42238 19.8858C2.3617 19.8607 2.30657 19.8239 2.26013 19.7775C2.21369 19.731 2.17687 19.6759 2.15175 19.6152C2.12664 19.5545 2.11373 19.4895 2.11377 19.4238Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                    </svg>
                  </div>
                  <p
                    aria-hidden="true"
                    style={{
                      maxWidth: "none",
                      fontSize: "20px",
                      lineHeight: "26px",
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontWeight: 800,
                    }}
                  >
                    Echange et remboursement sans frais, jusqu'à 30 min après
                    départ du train*
                  </p>
                  <span
                    style={{
                      fontSize: "16px",
                      lineHeight: "22px",
                      boxSizing: "border-box",
                      fontFamily: "Avenir",
                      fontWeight: 500,
                      border: "0px none rgb(12, 19, 31)",
                      clip: "rect(0px, 0px, 0px, 0px)",
                      height: "1px",
                      margin: "-1px",
                      overflow: "hidden",
                      padding: "0px",
                      position: "absolute",
                      whiteSpace: "nowrap",
                      width: "1px",
                    }}
                  >
                    Echange et remboursement sans frais, jusqu'à 30 min après
                    départ du train*
                  </span>
                </li>
                <li
                  style={{
                    boxSizing: "border-box",
                    display: "flex",
                    flexFlow: "row nowrap",
                    marginBottom: "16px",
                  }}
                >
                  <div style={{ boxSizing: "border-box" }}>
                    <svg
                      aria-hidden="true"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                      data-test="majorAvantages-2"
                      style={{
                        boxSizing: "border-box",
                        fill: "rgb(12, 19, 31)",
                        marginRight: "16px",
                        height: "24px",
                        width: "24px",
                      }}
                    >
                      <path
                        d="M2.11377 19.4238C2.11373 19.3582 2.12664 19.2931 2.15175 19.2324C2.17687 19.1718 2.21369 19.1166 2.26013 19.0702C2.30657 19.0238 2.3617 18.9869 2.42238 18.9618C2.48306 18.9367 2.5481 18.9238 2.61377 18.9238H4.48486C5.53557 18.9234 6.5499 19.3086 7.33545 20.0063L7.51904 20.1694C8.12172 20.7048 8.89993 21.0003 9.70605 21H16.4829C16.7511 21 17.0083 20.8935 17.198 20.7038C17.3876 20.5142 17.4941 20.257 17.4941 19.9888C17.4941 19.7206 17.3876 19.4634 17.198 19.2737C17.0083 19.0841 16.7511 18.9775 16.4829 18.9775C16.3503 18.9775 16.2231 18.9249 16.1294 18.8311C16.0356 18.7373 15.9829 18.6101 15.9829 18.4775C15.9829 18.3449 16.0356 18.2178 16.1294 18.124C16.2231 18.0302 16.3503 17.9775 16.4829 17.9775H17.625C17.8933 17.9775 18.1505 17.871 18.3402 17.6813C18.5299 17.4916 18.6365 17.2343 18.6365 16.966C18.6365 16.6978 18.5299 16.4405 18.3402 16.2508C18.1505 16.0611 17.8933 15.9545 17.625 15.9545C17.4924 15.9545 17.3652 15.9019 17.2714 15.8081C17.1777 15.7143 17.125 15.5871 17.125 15.4545C17.125 15.3219 17.1777 15.1948 17.2714 15.101C17.3652 15.0072 17.4924 14.9545 17.625 14.9545C17.6759 14.9545 17.7238 14.9659 17.7737 14.9696C17.8074 14.9588 17.8422 14.9518 17.8774 14.9487H18.5703C18.8385 14.9487 19.0957 14.8421 19.2854 14.6525C19.475 14.4629 19.5815 14.2056 19.5815 13.9375C19.5815 13.6693 19.475 13.412 19.2854 13.2224C19.0957 13.0328 18.8385 12.9262 18.5703 12.9262C18.4377 12.9262 18.3105 12.8735 18.2168 12.7798C18.123 12.686 18.0703 12.5588 18.0703 12.4262C18.0703 12.2936 18.123 12.1664 18.2168 12.0727C18.3105 11.9789 18.4377 11.9262 18.5703 11.9262H19.875C20.1427 11.9254 20.3992 11.8184 20.5882 11.6288C20.7772 11.4392 20.8833 11.1825 20.8833 10.9147C20.8833 10.647 20.7772 10.3902 20.5882 10.2006C20.3992 10.011 20.1427 9.90411 19.875 9.90327H11.8501C11.7175 9.90327 11.5903 9.85059 11.4965 9.75682C11.4028 9.66306 11.3501 9.53588 11.3501 9.40327C11.3501 9.27066 11.4028 9.14349 11.4965 9.04972C11.5903 8.95595 11.7175 8.90327 11.8501 8.90327H12.4595L12.9727 4.41011C12.9588 4.03012 12.7976 3.67043 12.5232 3.40723C12.2488 3.14402 11.8827 2.99797 11.5024 3H10.3364C10.2973 3.00019 10.2593 3.01291 10.2279 3.03628C10.1966 3.05965 10.1735 3.09245 10.1621 3.12988L8.59131 8.35742C8.44535 8.85127 8.14303 9.2844 7.7298 9.5917C7.31657 9.899 6.81476 10.0639 6.2998 10.0615H3.26318C3.13057 10.0615 3.00339 10.0088 2.90963 9.91507C2.81586 9.82131 2.76318 9.69413 2.76318 9.56152C2.76318 9.42891 2.81586 9.30173 2.90963 9.20797C3.00339 9.1142 3.13057 9.06152 3.26318 9.06152H6.2998C6.59949 9.06295 6.89154 8.96703 7.13203 8.78818C7.37251 8.60934 7.54842 8.35725 7.6333 8.06982L9.2041 2.84229C9.27824 2.59943 9.42815 2.38667 9.63189 2.23512C9.83563 2.08357 10.0825 2.00118 10.3364 2H11.5024C12.1565 2.00069 12.7835 2.2608 13.246 2.72327C13.7084 3.18573 13.9685 3.81278 13.9692 4.4668L13.4653 8.90332H19.875C20.3735 8.90337 20.8542 9.08851 21.2239 9.42286C21.5937 9.75721 21.8261 10.2169 21.8761 10.7129C21.9261 11.2089 21.7902 11.7058 21.4946 12.1072C21.1991 12.5086 20.765 12.786 20.2766 12.8856C20.4346 13.1372 20.5343 13.4209 20.5684 13.716C20.6025 14.0111 20.5701 14.3101 20.4737 14.5911C20.3772 14.8721 20.2191 15.1279 20.0109 15.3398C19.8027 15.5518 19.5497 15.7144 19.2705 15.8159C19.4556 16.0779 19.5748 16.3807 19.618 16.6986C19.6613 17.0165 19.6273 17.3401 19.519 17.6421C19.4106 17.9441 19.2312 18.2155 18.9957 18.4335C18.7603 18.6514 18.4758 18.8094 18.1664 18.8941C18.365 19.1971 18.4778 19.5482 18.4929 19.9101C18.508 20.2721 18.4248 20.6313 18.2522 20.9498C18.0796 21.2683 17.824 21.5341 17.5124 21.719C17.2009 21.9039 16.8452 22.001 16.4829 22H9.70605C8.6552 22.0005 7.64073 21.6153 6.855 20.9175L6.67141 20.7544C6.06887 20.2191 5.29084 19.9236 4.48488 19.9238H2.61377C2.5481 19.9239 2.48306 19.911 2.42238 19.8858C2.3617 19.8607 2.30657 19.8239 2.26013 19.7775C2.21369 19.731 2.17687 19.6759 2.15175 19.6152C2.12664 19.5545 2.11373 19.4895 2.11377 19.4238Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                    </svg>
                  </div>
                  <p
                    aria-hidden="true"
                    style={{
                      maxWidth: "none",
                      fontSize: "20px",
                      lineHeight: "26px",
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontWeight: 800,
                    }}
                  >
                    Votre carte est rentabilisée à partir de 3 allers-retours* !
                  </p>
                  <span
                    style={{
                      fontSize: "16px",
                      lineHeight: "22px",
                      boxSizing: "border-box",
                      fontFamily: "Avenir",
                      fontWeight: 500,
                      border: "0px none rgb(12, 19, 31)",
                      clip: "rect(0px, 0px, 0px, 0px)",
                      height: "1px",
                      margin: "-1px",
                      overflow: "hidden",
                      padding: "0px",
                      position: "absolute",
                      whiteSpace: "nowrap",
                      width: "1px",
                    }}
                  >
                    Votre carte est rentabilisée à partir de 3 allers-retours* !
                  </span>
                </li>
              </ul>
            </div>
            <hr
              aria-hidden="true"
              style={{
                boxSizing: "content-box",
                height: "8px",
                overflow: "visible",
                margin: "0px",
                flexShrink: 0,
                borderWidth: "0px",
                borderColor: "rgb(173, 255, 47)",
                backgroundColor: "rgb(255, 255, 255)",
                borderStyle: "none",
              }}
            />
            <div
              style={{
                padding: "56px 80px 16px",
                boxSizing: "border-box",
                marginTop: "32px",
              }}
            >
              <div
                style={{
                  marginBottom: "80px",
                  boxSizing: "border-box",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <h2
                  style={{
                    fontSize: "24px",
                    lineHeight: "30px",
                    boxSizing: "border-box",
                    margin: "0px 0px 24px",
                    fontFamily: "Avenir",
                    fontWeight: 800,
                    padding: "0px 16px",
                  }}
                >
                  La Carte Liberté vous donne accès à deux types de tarif :
                </h2>
                <div
                  style={{
                    boxSizing: "border-box",
                    display: "flex",
                    flexDirection: "column",
                    WebkitBoxPack: "center",
                    justifyContent: "center",
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      height: "256px",
                      boxSizing: "border-box",
                      position: "relative",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "none",
                        boxSizing: "border-box",
                        height: "100%",
                        width: "100%",
                      }}
                    >
                      <img
                        alt=""
                        src="https://www.sncf-connect.com/assets/styles/scale_and_crop_380x214/public/media/2022-01/bloc-offres-2.png?itok=yyAm3xN0"
                        style={{
                          borderRadius: "14px",
                          boxSizing: "border-box",
                          borderStyle: "none",
                          objectFit: "cover",
                          objectPosition: "50% 50%",
                          height: "100%",
                          width: "100%",
                        }}
                      />
                    </div>
                    <div
                      style={{
                        display: "block",
                        boxSizing: "border-box",
                        height: "256px",
                        width: "100%",
                      }}
                    >
                      <img
                        alt=""
                        src="https://www.sncf-connect.com/assets/styles/scale_and_crop_1275x256/public/media/2022-01/bloc-offres-2.png?itok=CiJnUf3Z"
                        style={{
                          borderRadius: "14px",
                          boxSizing: "border-box",
                          borderStyle: "none",
                          objectFit: "cover",
                          objectPosition: "50% 50%",
                          height: "256px",
                          width: "100%",
                        }}
                      />
                    </div>
                  </div>
                  <ul
                    role="list"
                    style={{
                      WebkitBoxAlign: "stretch",
                      alignItems: "stretch",
                      flexDirection: "row",
                      justifyContent: "space-evenly",
                      margin: "-128px 0px 0px",
                      padding: "0px",
                      boxSizing: "border-box",
                      display: "flex",
                      WebkitBoxPack: "center",
                      listStyle: "outside none none",
                      zIndex: 1,
                    }}
                  >
                    <li
                      style={{
                        margin: "0px 16px",
                        width: "18.875rem",
                        boxSizing: "border-box",
                        marginBottom: "0px",
                        maxWidth: "328px",
                      }}
                    >
                      <div
                        style={{
                          height: "632px",
                          minHeight: "370px",
                          boxSizing: "border-box",
                          color: "rgb(12, 19, 31)",
                          transition:
                            "box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                          borderRadius: "14px",
                          overflow: "hidden",
                          boxShadow: "none",
                          border: "0px none rgb(12, 19, 31)",
                          background:
                            "rgb(255, 255, 255) none repeat scroll 0% 0% / auto padding-box border-box",
                          WebkitBoxAlign: "stretch",
                          alignItems: "stretch",
                          display: "flex",
                          width: "100%",
                        }}
                      >
                        <div
                          style={{
                            minHeight: "284px",
                            boxSizing: "border-box",
                            paddingBottom: "32px",
                            display: "flex",
                            flexDirection: "column",
                            WebkitBoxPack: "justify",
                            justifyContent: "space-between",
                            padding: "24px 16px 32px",
                          }}
                        >
                          <div style={{ boxSizing: "border-box" }}>
                            <h3
                              style={{
                                fontSize: "16px",
                                lineHeight: "22px",
                                boxSizing: "border-box",
                                margin: "0px",
                                fontFamily:
                                  "Avenir",
                                fontWeight: 500,
                                paddingBottom: "4px",
                              }}
                            >
                              Le tarif Liberté
                            </h3>
                            <p
                              style={{
                                fontSize: "16px",
                                lineHeight: "22px",
                                boxSizing: "border-box",
                                margin: "0px",
                                fontFamily:
                                  "Avenir",
                                fontWeight: 500,
                                color: "rgb(94, 104, 120)",
                                whiteSpace: "pre-line",
                              }}
                            >
                              Disponible tous les jours uniquement pour le
                              titulaire de la carte : - Billet 100% flexible :
                              Echange et remboursement sans frais jusqu’à 30 min
                              après le départ du train - Des prix fixes toute
                              l’année, par destination et par classe, même en
                              dernière minute - 45% de réduction en Business
                              Première, même en dernière minute - Echange
                              garanti le jour du départ du train, y compris sur
                              train complet (sans garantie de place assise)
                              ------------- Le tarif idéal pour les voyages pros
                              qui ne se passent pas toujours comme prévu !
                            </p>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li
                      style={{
                        margin: "0px 16px",
                        width: "18.875rem",
                        boxSizing: "border-box",
                        marginBottom: "0px",
                        maxWidth: "328px",
                      }}
                    >
                      <div
                        style={{
                          height: "632px",
                          minHeight: "370px",
                          boxSizing: "border-box",
                          color: "rgb(12, 19, 31)",
                          transition:
                            "box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                          borderRadius: "14px",
                          overflow: "hidden",
                          boxShadow: "none",
                          border: "0px none rgb(12, 19, 31)",
                          background:
                            "rgb(255, 255, 255) none repeat scroll 0% 0% / auto padding-box border-box",
                          WebkitBoxAlign: "stretch",
                          alignItems: "stretch",
                          display: "flex",
                          width: "100%",
                        }}
                      >
                        <div
                          style={{
                            minHeight: "284px",
                            boxSizing: "border-box",
                            paddingBottom: "32px",
                            display: "flex",
                            flexDirection: "column",
                            WebkitBoxPack: "justify",
                            justifyContent: "space-between",
                            padding: "24px 16px 32px",
                          }}
                        >
                          <div style={{ boxSizing: "border-box" }}>
                            <h3
                              style={{
                                fontSize: "16px",
                                lineHeight: "22px",
                                boxSizing: "border-box",
                                margin: "0px",
                                fontFamily:
                                  "Avenir",
                                fontWeight: 500,
                                paddingBottom: "4px",
                              }}
                            >
                              Le tarif Avantage
                            </h3>
                            <p
                              style={{
                                fontSize: "16px",
                                lineHeight: "22px",
                                boxSizing: "border-box",
                                margin: "0px",
                                fontFamily:
                                  "Avenir",
                                fontWeight: 500,
                                color: "rgb(94, 104, 120)",
                                whiteSpace: "pre-line",
                              }}
                            >
                              Disponible* pour le titulaire et ses accompagnants
                              (1 adulte et jusqu’à 3 enfants) : - Billet
                              semi-flexible : Echange et remboursement sans
                              frais jusqu’à 7 jours avant le départ du train -
                              30% de réduction* en 2nde et en 1ère classe sur le
                              tarif du jour (-60% pour les enfants) - Prix
                              plafonnés en 2nde classe même en dernière minute,
                              en fonction du temps de trajet. *voir conditions
                              ------------- Le tarif très avantageux pour vos
                              voyages loisirs (seul ou en famille) qui
                              nécessitent moins de flexibilité.
                            </p>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div
                style={{
                  boxSizing: "border-box",
                  display: "flex",
                  flexDirection: "column",
                  margin: "32px 0px 24px",
                }}
              >
                <h2
                  style={{
                    fontSize: "24px",
                    lineHeight: "30px",
                    boxSizing: "border-box",
                    margin: "0px 0px 24px",
                    fontFamily: "Avenir",
                    fontWeight: 800,
                    padding: "0px 16px",
                  }}
                >
                  Comment me procurer une Carte Liberté ?
                </h2>
                <ol
                  style={{
                    flexDirection: "row",
                    margin: "0px 0px 48px",
                    boxSizing: "border-box",
                    display: "flex",
                    WebkitBoxPack: "center",
                    justifyContent: "center",
                    padding: "0px",
                  }}
                >
                  <li
                    style={{
                      paddingRight: "40px",
                      position: "relative",
                      width: "18.875rem",
                      boxSizing: "border-box",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        boxSizing: "border-box",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "column",
                        WebkitBoxPack: "center",
                        justifyContent: "center",
                        marginBottom: "24px",
                      }}
                    >
                      <svg
                        aria-hidden="true"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                        data-test="icon-1"
                        style={{
                          boxSizing: "border-box",
                          fill: "rgb(12, 19, 31)",
                          marginBottom: "16px",
                          height: "70px",
                          width: "4.375rem",
                        }}
                      >
                        <path
                          d="M12 2C6.49434 2 2 6.49438 2 12C2 17.5056 6.49434 22 12 22C17.5056 22 22 17.5056 22 12C22 6.49438 17.5056 2 12 2ZM12 20.8764C7.11232 20.8764 3.1236 16.8876 3.1236 12C3.1236 7.11236 7.11232 3.1236 12 3.1236C16.8876 3.1236 20.8764 7.11236 20.8764 12C20.8764 16.8876 16.8876 20.8764 12 20.8764Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                        <path
                          d="M11.9194 10.2786L10.5161 11.1811L10 10.3203L12.1129 9H13V15H11.9194V10.2786Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                      </svg>
                      <p
                        style={{
                          fontSize: "20px",
                          lineHeight: "26px",
                          boxSizing: "border-box",
                          margin: "0px 0px 4px",
                          fontFamily:
                            "Avenir",
                          fontWeight: 800,
                        }}
                      >
                        Dès maintenant
                      </p>
                      <p
                        style={{
                          fontSize: "16px",
                          lineHeight: "22px",
                          boxSizing: "border-box",
                          margin: "0px",
                          fontFamily:
                            "Avenir",
                          fontWeight: 500,
                          textAlign: "center",
                        }}
                      >
                        achetez ou renouvelez votre nouvelle Carte Liberté en
                        ligne.
                      </p>
                    </div>
                    <svg
                      aria-hidden="true"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{
                        boxSizing: "border-box",
                        fill: "rgb(94, 104, 120)",
                        height: "48px",
                        width: "3rem",
                        position: "absolute",
                        right: "-15px",
                        top: "8px",
                      }}
                    >
                      <path
                        d="M8.79362 6.6659C8.36568 7.06175 8.36568 7.73825 8.79362 8.1341L12.973 12L8.79362 15.8659C8.36568 16.2617 8.36568 16.9383 8.79362 17.3341L8.83447 17.3719C9.21775 17.7264 9.80928 17.7264 10.1926 17.3719L15.2064 12.7341C15.6343 12.3383 15.6343 11.6617 15.2064 11.2659L10.1926 6.62811C9.80928 6.27358 9.21775 6.27358 8.83447 6.62811L8.79362 6.6659Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                    </svg>
                  </li>
                  <li
                    style={{
                      marginLeft: "24px",
                      paddingRight: "40px",
                      position: "relative",
                      width: "18.875rem",
                      boxSizing: "border-box",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        boxSizing: "border-box",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "column",
                        WebkitBoxPack: "center",
                        justifyContent: "center",
                        marginBottom: "24px",
                      }}
                    >
                      <svg
                        aria-hidden="true"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                        data-test="icon-2"
                        style={{
                          boxSizing: "border-box",
                          fill: "rgb(12, 19, 31)",
                          marginBottom: "16px",
                          height: "70px",
                          width: "4.375rem",
                        }}
                      >
                        <path
                          d="M12 2C6.49434 2 2 6.49438 2 12C2 17.5056 6.49434 22 12 22C17.5056 22 22 17.5056 22 12C22 6.49438 17.5056 2 12 2ZM12 20.8764C7.11232 20.8764 3.1236 16.8876 3.1236 12C3.1236 7.11236 7.11232 3.1236 12 3.1236C16.8876 3.1236 20.8764 7.11236 20.8764 12C20.8764 16.8876 16.8876 20.8764 12 20.8764Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                        <path
                          d="M10 15V14.4493C10 14.1753 10.0342 13.9288 10.1026 13.7096C10.1709 13.4904 10.2678 13.2904 10.3932 13.1096C10.5185 12.9288 10.6695 12.7616 10.8462 12.6082C11.0285 12.4548 11.2336 12.3041 11.4615 12.1562L11.9316 11.8603C12.0684 11.7671 12.1909 11.6849 12.2991 11.6137C12.4131 11.5425 12.5071 11.4658 12.5812 11.3836C12.661 11.3014 12.7208 11.2082 12.7607 11.1041C12.8063 10.9945 12.8291 10.863 12.8291 10.7096C12.8291 10.1507 12.5328 9.87123 11.9402 9.87123C11.661 9.87123 11.4188 9.93151 11.2137 10.0521C11.0085 10.1726 10.8148 10.3068 10.6325 10.4548L10.1197 9.60822C10.4729 9.38356 10.8063 9.2274 11.1197 9.13973C11.433 9.04658 11.7635 9 12.1111 9C12.6752 9 13.1254 9.14247 13.4615 9.4274C13.8034 9.71233 13.9744 10.137 13.9744 10.7014C13.9744 10.9479 13.9316 11.1616 13.8462 11.3425C13.7607 11.5233 13.6467 11.6849 13.5043 11.8274C13.3675 11.9699 13.2108 12.0986 13.0342 12.2137C12.8632 12.3288 12.6895 12.4438 12.5128 12.5589L11.9487 12.9288C11.6695 13.1041 11.4587 13.2877 11.3162 13.4795C11.1795 13.6658 11.0997 13.8548 11.0769 14.0466H14V15H10Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                      </svg>
                      <p
                        style={{
                          fontSize: "20px",
                          lineHeight: "26px",
                          boxSizing: "border-box",
                          margin: "0px 0px 4px",
                          fontFamily:
                            "Avenir",
                          fontWeight: 800,
                        }}
                      >
                        Choisissez
                      </p>
                      <p
                        style={{
                          fontSize: "16px",
                          lineHeight: "22px",
                          boxSizing: "border-box",
                          margin: "0px",
                          fontFamily:
                            "Avenir",
                          fontWeight: 500,
                          textAlign: "center",
                        }}
                      >
                        sa date de début de validité jusqu'à 5 mois par rapport
                        à sa date d'achat.
                      </p>
                    </div>
                    <svg
                      aria-hidden="true"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{
                        boxSizing: "border-box",
                        fill: "rgb(94, 104, 120)",
                        height: "48px",
                        width: "3rem",
                        position: "absolute",
                        right: "-15px",
                        top: "8px",
                      }}
                    >
                      <path
                        d="M8.79362 6.6659C8.36568 7.06175 8.36568 7.73825 8.79362 8.1341L12.973 12L8.79362 15.8659C8.36568 16.2617 8.36568 16.9383 8.79362 17.3341L8.83447 17.3719C9.21775 17.7264 9.80928 17.7264 10.1926 17.3719L15.2064 12.7341C15.6343 12.3383 15.6343 11.6617 15.2064 11.2659L10.1926 6.62811C9.80928 6.27358 9.21775 6.27358 8.83447 6.62811L8.79362 6.6659Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                    </svg>
                  </li>
                  <li
                    style={{
                      marginLeft: "24px",
                      paddingRight: "40px",
                      position: "relative",
                      width: "18.875rem",
                      boxSizing: "border-box",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        boxSizing: "border-box",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "column",
                        WebkitBoxPack: "center",
                        justifyContent: "center",
                        marginBottom: "24px",
                      }}
                    >
                      <svg
                        aria-hidden="true"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                        data-test="icon-3"
                        style={{
                          boxSizing: "border-box",
                          fill: "rgb(12, 19, 31)",
                          marginBottom: "16px",
                          height: "70px",
                          width: "4.375rem",
                        }}
                      >
                        <path
                          d="M12 2C6.49434 2 2 6.49438 2 12C2 17.5056 6.49434 22 12 22C17.5056 22 22 17.5056 22 12C22 6.49438 17.5056 2 12 2ZM12 20.8764C7.11232 20.8764 3.1236 16.8876 3.1236 12C3.1236 7.11236 7.11232 3.1236 12 3.1236C16.8876 3.1236 20.8764 7.11236 20.8764 12C20.8764 16.8876 16.8876 20.8764 12 20.8764Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                        <path
                          d="M14 13.0997C14 13.3962 13.9471 13.6631 13.8413 13.9003C13.7354 14.1321 13.5873 14.3315 13.3968 14.4987C13.2116 14.6604 12.9894 14.7844 12.7302 14.8706C12.4762 14.9569 12.1984 15 11.8968 15C11.4841 15 11.1217 14.9191 10.8095 14.7574C10.5026 14.5957 10.2328 14.3288 10 13.9569L10.7857 13.3585C10.9074 13.5957 11.0503 13.7898 11.2143 13.9407C11.3836 14.0863 11.6217 14.159 11.9286 14.159C12.2566 14.159 12.5079 14.0674 12.6825 13.8841C12.8624 13.6954 12.9524 13.4528 12.9524 13.1563C12.9524 12.8491 12.8571 12.6253 12.6667 12.4852C12.4815 12.3396 12.2381 12.2668 11.9365 12.2668C11.7037 12.2668 11.5079 12.283 11.3492 12.3154V11.4178H11.6111C11.7328 11.4178 11.8492 11.4151 11.9603 11.4097C12.0767 11.3989 12.1852 11.3747 12.2857 11.3369C12.418 11.2884 12.5238 11.2049 12.6032 11.0863C12.6825 10.9677 12.7222 10.7978 12.7222 10.5768C12.7222 10.3396 12.6455 10.159 12.4921 10.035C12.3439 9.90566 12.1402 9.84097 11.881 9.84097C11.7487 9.84097 11.6243 9.85714 11.5079 9.88949C11.3968 9.92183 11.2937 9.96496 11.1984 10.0189C11.1032 10.0674 11.0159 10.124 10.9365 10.1887C10.8624 10.248 10.7937 10.3046 10.7302 10.3585L10.2619 9.54986C10.5317 9.37197 10.8095 9.2372 11.0952 9.14555C11.3862 9.04852 11.6931 9 12.0159 9C12.254 9 12.4762 9.02965 12.6825 9.08895C12.8942 9.14286 13.0794 9.23181 13.2381 9.35579C13.3968 9.47439 13.5212 9.62534 13.6111 9.80863C13.7063 9.98652 13.754 10.2022 13.754 10.4555C13.754 10.6065 13.7302 10.7466 13.6825 10.876C13.6349 11 13.5714 11.1132 13.4921 11.2156C13.4127 11.3181 13.3201 11.407 13.2143 11.4825C13.1138 11.558 13.0079 11.6199 12.8968 11.6685V11.6927C13.0344 11.7197 13.1667 11.7709 13.2937 11.8464C13.4259 11.9164 13.545 12.0108 13.6508 12.1294C13.7566 12.2426 13.8413 12.3801 13.9048 12.5418C13.9683 12.7035 14 12.8895 14 13.0997Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                      </svg>
                      <p
                        style={{
                          fontSize: "20px",
                          lineHeight: "26px",
                          boxSizing: "border-box",
                          margin: "0px 0px 4px",
                          fontFamily:
                            "Avenir",
                          fontWeight: 800,
                        }}
                      >
                        Retrouvez-la
                      </p>
                      <p
                        style={{
                          fontSize: "16px",
                          lineHeight: "22px",
                          boxSizing: "border-box",
                          margin: "0px",
                          fontFamily:
                            "Avenir",
                          fontWeight: 500,
                          textAlign: "center",
                        }}
                      >
                        au format PDF en pièce jointe de l’e-mail de
                        confirmation d'achat envoyé au titulaire de la carte.
                      </p>
                    </div>
                    <svg
                      aria-hidden="true"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{
                        boxSizing: "border-box",
                        fill: "rgb(94, 104, 120)",
                        height: "48px",
                        width: "3rem",
                        position: "absolute",
                        right: "-15px",
                        top: "8px",
                      }}
                    >
                      <path
                        d="M8.79362 6.6659C8.36568 7.06175 8.36568 7.73825 8.79362 8.1341L12.973 12L8.79362 15.8659C8.36568 16.2617 8.36568 16.9383 8.79362 17.3341L8.83447 17.3719C9.21775 17.7264 9.80928 17.7264 10.1926 17.3719L15.2064 12.7341C15.6343 12.3383 15.6343 11.6617 15.2064 11.2659L10.1926 6.62811C9.80928 6.27358 9.21775 6.27358 8.83447 6.62811L8.79362 6.6659Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                    </svg>
                  </li>
                  <li
                    style={{
                      marginLeft: "24px",
                      paddingRight: "40px",
                      position: "relative",
                      width: "18.875rem",
                      boxSizing: "border-box",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        boxSizing: "border-box",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "column",
                        WebkitBoxPack: "center",
                        justifyContent: "center",
                        marginBottom: "24px",
                      }}
                    >
                      <svg
                        aria-hidden="true"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                        data-test="icon-4"
                        style={{
                          boxSizing: "border-box",
                          fill: "rgb(12, 19, 31)",
                          marginBottom: "16px",
                          height: "70px",
                          width: "4.375rem",
                        }}
                      >
                        <path
                          d="M12 2C6.49434 2 2 6.49438 2 12C2 17.5056 6.49434 22 12 22C17.5056 22 22 17.5056 22 12C22 6.49438 17.5056 2 12 2ZM12 20.8764C7.11232 20.8764 3.1236 16.8876 3.1236 12C3.1236 7.11236 7.11232 3.1236 12 3.1236C16.8876 3.1236 20.8764 7.11236 20.8764 12C20.8764 16.8876 16.8876 20.8764 12 20.8764Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                        <path
                          d="M12.4264 9.96266L10.8527 12.8091H12.4264V9.96266ZM13.4031 13.7801V15H12.4264V13.7801H10V12.7261L12.1318 9H13.4031V12.7925H14V13.7801H13.4031Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                      </svg>
                      <p
                        style={{
                          fontSize: "20px",
                          lineHeight: "26px",
                          boxSizing: "border-box",
                          margin: "0px 0px 4px",
                          fontFamily:
                            "Avenir",
                          fontWeight: 800,
                        }}
                      >
                        Économisez
                      </p>
                      <p
                        style={{
                          fontSize: "16px",
                          lineHeight: "22px",
                          boxSizing: "border-box",
                          margin: "0px",
                          fontFamily:
                            "Avenir",
                          fontWeight: 500,
                          textAlign: "center",
                        }}
                      >
                        toute l'année grâce à ses réductions et multiples
                        avantages !
                      </p>
                    </div>
                  </li>
                </ol>
              </div>
              <div
                style={{
                  display: "flex",
                  flexFlow: "row nowrap",
                  boxSizing: "border-box",
                }}
              >
                <div
                  style={{
                    marginRight: "12px",
                    boxSizing: "border-box",
                    WebkitBoxAlign: "center",
                    alignItems: "center",
                    display: "flex",
                    flexDirection: "column",
                    WebkitBoxPack: "center",
                    justifyContent: "center",
                    marginBottom: "24px",
                    maxWidth: "628px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      maxWidth: "100%",
                      boxSizing: "border-box",
                      color: "rgb(12, 19, 31)",
                      transition:
                        "box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                      borderRadius: "14px",
                      overflow: "hidden",
                      boxShadow: "none",
                      border: "0px none rgb(12, 19, 31)",
                      background:
                        "rgb(255, 255, 255) none repeat scroll 0% 0% / auto padding-box border-box",
                      height: "265px",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        padding: "32px 32px 16px",
                        boxSizing: "border-box",
                        paddingBottom: "16px",
                        display: "flex",
                        flexDirection: "column",
                        WebkitBoxPack: "justify",
                        justifyContent: "space-between",
                        minHeight: "265px",
                      }}
                    >
                      <div style={{ boxSizing: "border-box" }}>
                        <h3
                          style={{
                            fontSize: "20px",
                            lineHeight: "26px",
                            boxSizing: "border-box",
                            margin: "0px 0px 16px",
                            fontFamily:
                              "Avenir",
                            fontWeight: 800,
                          }}
                        >
                          Adhérer au Contrat Pro
                        </h3>
                        <p
                          style={{
                            fontSize: "16px",
                            lineHeight: "22px",
                            boxSizing: "border-box",
                            margin: "0px",
                            fontFamily:
                              "Avenir",
                            fontWeight: 500,
                          }}
                        >
                          En souscrivant gratuitement au Contrat Pro, vous
                          bénéficierez d'une remise de 50€ sur votre carte
                          Liberté TGV INOUI.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    marginLeft: "12px",
                    boxSizing: "border-box",
                    WebkitBoxAlign: "center",
                    alignItems: "center",
                    display: "flex",
                    flexDirection: "column",
                    WebkitBoxPack: "center",
                    justifyContent: "center",
                    marginBottom: "24px",
                    maxWidth: "628px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      maxWidth: "100%",
                      boxSizing: "border-box",
                      color: "rgb(12, 19, 31)",
                      transition:
                        "box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                      borderRadius: "14px",
                      overflow: "hidden",
                      boxShadow: "none",
                      border: "0px none rgb(12, 19, 31)",
                      background:
                        "rgb(255, 255, 255) none repeat scroll 0% 0% / auto padding-box border-box",
                      height: "265px",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        padding: "32px 32px 16px",
                        boxSizing: "border-box",
                        paddingBottom: "16px",
                        display: "flex",
                        flexDirection: "column",
                        WebkitBoxPack: "justify",
                        justifyContent: "space-between",
                        minHeight: "265px",
                      }}
                    >
                      <div style={{ boxSizing: "border-box" }}>
                        <h3
                          style={{
                            fontSize: "20px",
                            lineHeight: "26px",
                            boxSizing: "border-box",
                            margin: "0px 0px 16px",
                            fontFamily:
                              "Avenir",
                            fontWeight: 800,
                          }}
                        >
                          Payer avec votre Crédit Mobilité
                        </h3>
                        <p
                          style={{
                            fontSize: "16px",
                            lineHeight: "22px",
                            boxSizing: "border-box",
                            margin: "0px",
                            fontFamily:
                              "Avenir",
                            fontWeight: 500,
                          }}
                        >
                          Achetez votre Carte Liberté avec Ayvens, Betterway ou
                          Worklife, partenaires mobilité de votre employeur.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ marginBottom: "72px", boxSizing: "border-box" }}>
                <h2
                  style={{
                    fontSize: "24px",
                    lineHeight: "30px",
                    boxSizing: "border-box",
                    margin: "0px 0px 16px",
                    fontFamily: "Avenir",
                    fontWeight: 800,
                  }}
                >
                  Pourquoi choisir la Carte Liberté ?
                </h2>
                <ul
                  role="list"
                  style={{
                    display: "grid",
                    gap: "24px",
                    gridTemplateColumns: "394.656px 394.672px 394.656px",
                    boxSizing: "border-box",
                    listStyle: "outside none none",
                    margin: "0px",
                    padding: "0px",
                  }}
                >
                  <li style={{ boxSizing: "border-box" }}>
                    <div
                      style={{
                        height: "442px",
                        boxSizing: "border-box",
                        color: "rgb(12, 19, 31)",
                        transition:
                          "box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                        borderRadius: "14px",
                        overflow: "hidden",
                        boxShadow: "none",
                        border: "0px none rgb(12, 19, 31)",
                        background:
                          "rgb(255, 255, 255) none repeat scroll 0% 0% / auto padding-box border-box",
                      }}
                    >
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          flexDirection: "column",
                          position: "relative",
                        }}
                      >
                        <div style={{ boxSizing: "border-box" }}>
                          <div
                            style={{
                              display: "none",
                              boxSizing: "border-box",
                              padding: "0px",
                              position: "relative",
                              zIndex: 1,
                              height: "200px",
                            }}
                          >
                            <img
                              src="https://www.sncf-connect.com/assets/styles/scale_and_crop_705x355/public/media/2022-09/reunion-a-bord-du-train.jpg?itok=pLOWJH7x"
                              alt=""
                              style={{
                                boxSizing: "border-box",
                                borderStyle: "none",
                                display: "block",
                                backgroundSize: "cover",
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "50% 50%",
                                width: "100%",
                                objectFit: "cover",
                                height: "100%",
                                borderRadius: "0px",
                              }}
                            />
                          </div>
                          <div
                            style={{
                              display: "block",
                              boxSizing: "border-box",
                              padding: "0px",
                              position: "relative",
                              zIndex: 1,
                              height: "200px",
                            }}
                          >
                            <img
                              src="https://www.sncf-connect.com/assets/styles/scale_and_crop_705x355/public/media/2022-09/reunion-a-bord-du-train.jpg?itok=pLOWJH7x"
                              alt=""
                              style={{
                                boxSizing: "border-box",
                                borderStyle: "none",
                                display: "block",
                                backgroundSize: "cover",
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "50% 50%",
                                width: "100%",
                                objectFit: "cover",
                                height: "200px",
                                borderRadius: "0px",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          flexDirection: "column",
                          height: "192px",
                          WebkitBoxPack: "justify",
                          justifyContent: "space-between",
                          minHeight: "auto",
                          padding: "24px 16px 16px",
                        }}
                      >
                        <section style={{ boxSizing: "border-box" }}>
                          <div
                            data-test="titleAndDescription"
                            style={{
                              fontSize: "16px",
                              lineHeight: "22px",
                              boxSizing: "border-box",
                              margin: "0px",
                              fontFamily:
                                "Avenir",
                              fontWeight: 500,
                            }}
                          >
                            <div
                              style={{
                                fontSize: "16px",
                                lineHeight: "22px",
                                boxSizing: "border-box",
                                margin: "0px",
                                fontFamily:
                                  "Avenir",
                                fontWeight: 500,
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                display: "flex",
                                WebkitBoxPack: "justify",
                                justifyContent: "space-between",
                              }}
                            >
                              <h3
                                aria-hidden="false"
                                style={{
                                  fontSize: "20px",
                                  lineHeight: "26px",
                                  boxSizing: "border-box",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 800,
                                }}
                              >
                                Carte Liberté TGV INOUI : nos clients en parlent
                              </h3>
                            </div>{" "}
                            <span
                              style={{
                                fontSize: "16px",
                                lineHeight: "22px",
                                marginTop: "8px",
                                boxSizing: "border-box",
                                margin: "8px 0px 0px",
                                fontFamily:
                                  "Avenir",
                                fontWeight: 500,
                                color: "rgb(94, 104, 120)",
                                whiteSpace: "pre-line",
                                display: "-webkit-box",
                                overflow: "hidden",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 3,
                              }}
                            >
                              Ils voyagent très souvent en train pour le travail
                              ou simplement pour leurs loisirs. Nos 4 clients
                              ont choisi la Carte Liberté TGV INOUI pour
                              voyager…
                            </span>
                          </div>
                        </section>
                      </div>
                      <hr
                        aria-hidden="true"
                        style={{
                          boxSizing: "content-box",
                          height: "2px",
                          overflow: "visible",
                          margin: "0px",
                          flexShrink: 0,
                          borderWidth: "0px",
                          borderColor: "rgb(173, 255, 47)",
                          backgroundColor: "rgb(243, 243, 248)",
                          borderStyle: "none",
                        }}
                      />
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          flex: "1 1 auto",
                          WebkitBoxPack: "center",
                          justifyContent: "center",
                        }}
                      >
                        <a
                          data-test="linkButton"
                          aria-label="Découvrir: Carte Liberté TGV INOUI : nos clients en parlent"
                          href="/article/la-carte-liberte-pourquoi-lacheter"
                          target="_blank"
                          title="Découvrir - Nouvel Onglet"
                          rel="noopener noreferrer"
                          style={{
                            fontSize: "13px",
                            lineHeight: "18px",
                            boxSizing: "border-box",
                            backgroundColor: "rgba(0, 0, 0, 0)",
                            margin: "0px",
                            fontFamily:
                              "Avenir",
                            fontWeight: 500,
                            color: "rgb(20, 112, 138)",
                            textDecoration: "none solid rgb(20, 112, 138)",
                            cursor: "pointer",
                            position: "relative",
                            WebkitBoxAlign: "center",
                            alignItems: "center",
                            display: "flex",
                            padding: "15px",
                            boxShadow: "none",
                            WebkitBoxPack: "center",
                            justifyContent: "center",
                            textTransform: "none",
                          }}
                        >
                          Découvrir
                          <svg
                            aria-hidden="true"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{
                              boxSizing: "border-box",
                              height: "16px",
                              width: "1rem",
                              alignSelf: "normal",
                              fill: "rgb(20, 112, 138)",
                              flexShrink: 0,
                              marginLeft: "6px",
                            }}
                          >
                            <path
                              d="M12 0C9.62663 0 7.30655 0.703788 5.33316 2.02236C3.35977 3.34094 1.8217 5.21508 0.913451 7.4078C0.00519941 9.60051 -0.232441 12.0133 0.230582 14.3411C0.693605 16.6689 1.83649 18.807 3.51472 20.4853C5.19295 22.1635 7.33115 23.3064 9.65892 23.7694C11.9867 24.2324 14.3995 23.9948 16.5922 23.0865C18.7849 22.1783 20.6591 20.6402 21.9776 18.6668C23.2962 16.6934 24 14.3734 24 12C24 10.4241 23.6896 8.8637 23.0866 7.4078C22.4835 5.95189 21.5996 4.62902 20.4853 3.51472C19.371 2.40041 18.0481 1.5165 16.5922 0.913445C15.1363 0.310389 13.5759 0 12 0ZM16.0464 12.5177L11.4398 16.9615C11.3024 17.094 11.118 17.1666 10.9271 17.1632C10.7362 17.1598 10.5545 17.0807 10.422 16.9433C10.2894 16.806 10.2169 16.6215 10.2203 16.4307C10.2237 16.2398 10.3028 16.0581 10.4402 15.9256L14.5095 11.9998L10.4402 8.07458C10.3028 7.94203 10.2237 7.76033 10.2203 7.56946C10.2169 7.37859 10.2894 7.19419 10.422 7.05681C10.5545 6.91944 10.7362 6.84035 10.9271 6.83694C11.118 6.83354 11.3024 6.90609 11.4398 7.03865L16.0464 11.4818C16.1161 11.5489 16.1715 11.6293 16.2093 11.7183C16.2472 11.8073 16.2667 11.9031 16.2667 11.9998C16.2667 12.0965 16.2472 12.1922 16.2093 12.2812C16.1715 12.3702 16.1161 12.4507 16.0464 12.5177Z"
                              style={{ boxSizing: "border-box" }}
                            ></path>
                          </svg>
                        </a>
                      </div>
                    </div>
                  </li>
                  <li style={{ boxSizing: "border-box" }}>
                    <div
                      style={{
                        height: "442px",
                        boxSizing: "border-box",
                        color: "rgb(12, 19, 31)",
                        transition:
                          "box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                        borderRadius: "14px",
                        overflow: "hidden",
                        boxShadow: "none",
                        border: "0px none rgb(12, 19, 31)",
                        background:
                          "rgb(255, 255, 255) none repeat scroll 0% 0% / auto padding-box border-box",
                      }}
                    >
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          flexDirection: "column",
                          position: "relative",
                        }}
                      >
                        <div style={{ boxSizing: "border-box" }}>
                          <div
                            style={{
                              display: "none",
                              boxSizing: "border-box",
                              padding: "0px",
                              position: "relative",
                              zIndex: 1,
                              height: "200px",
                            }}
                          >
                            <img
                              src="https://www.sncf-connect.com/assets/styles/scale_and_crop_705x355/public/media/2021-08/voyage-pro-attente-istock-tempura.jpg?itok=0VwLP7xE"
                              alt=""
                              style={{
                                boxSizing: "border-box",
                                borderStyle: "none",
                                display: "block",
                                backgroundSize: "cover",
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "50% 50%",
                                width: "100%",
                                objectFit: "cover",
                                height: "100%",
                                borderRadius: "0px",
                              }}
                            />
                          </div>
                          <div
                            style={{
                              display: "block",
                              boxSizing: "border-box",
                              padding: "0px",
                              position: "relative",
                              zIndex: 1,
                              height: "200px",
                            }}
                          >
                            <img
                              src="https://www.sncf-connect.com/assets/styles/scale_and_crop_705x355/public/media/2021-08/voyage-pro-attente-istock-tempura.jpg?itok=0VwLP7xE"
                              alt=""
                              style={{
                                boxSizing: "border-box",
                                borderStyle: "none",
                                display: "block",
                                backgroundSize: "cover",
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "50% 50%",
                                width: "100%",
                                objectFit: "cover",
                                height: "200px",
                                borderRadius: "0px",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          flexDirection: "column",
                          height: "192px",
                          WebkitBoxPack: "justify",
                          justifyContent: "space-between",
                          minHeight: "auto",
                          padding: "24px 16px 16px",
                        }}
                      >
                        <section style={{ boxSizing: "border-box" }}>
                          <div
                            data-test="titleAndDescription"
                            style={{
                              fontSize: "16px",
                              lineHeight: "22px",
                              boxSizing: "border-box",
                              margin: "0px",
                              fontFamily:
                                "Avenir",
                              fontWeight: 500,
                            }}
                          >
                            <div
                              style={{
                                fontSize: "16px",
                                lineHeight: "22px",
                                boxSizing: "border-box",
                                margin: "0px",
                                fontFamily:
                                  "Avenir",
                                fontWeight: 500,
                                WebkitBoxAlign: "center",
                                alignItems: "center",
                                display: "flex",
                                WebkitBoxPack: "justify",
                                justifyContent: "space-between",
                              }}
                            >
                              <h3
                                aria-hidden="false"
                                style={{
                                  fontSize: "20px",
                                  lineHeight: "26px",
                                  boxSizing: "border-box",
                                  margin: "0px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 800,
                                }}
                              >
                                La Carte Liberté, pour des déplacements
                                professionnels éco-responsables&nbsp;!
                              </h3>
                            </div>{" "}
                            <span
                              style={{
                                fontSize: "16px",
                                lineHeight: "22px",
                                marginTop: "8px",
                                boxSizing: "border-box",
                                margin: "8px 0px 0px",
                                fontFamily:
                                  "Avenir",
                                fontWeight: 500,
                                color: "rgb(94, 104, 120)",
                                whiteSpace: "pre-line",
                                display: "-webkit-box",
                                overflow: "hidden",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 3,
                              }}
                            >
                              Vous êtes une entreprise avec une politique RSE
                              forte ? La Carte Liberté, c'est la garantie de
                              réductions sur les déplacements en train toute
                              l'année…
                            </span>
                          </div>
                        </section>
                      </div>
                      <hr
                        aria-hidden="true"
                        style={{
                          boxSizing: "content-box",
                          height: "2px",
                          overflow: "visible",
                          margin: "0px",
                          flexShrink: 0,
                          borderWidth: "0px",
                          borderColor: "rgb(173, 255, 47)",
                          backgroundColor: "rgb(243, 243, 248)",
                          borderStyle: "none",
                        }}
                      />
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          flex: "1 1 auto",
                          WebkitBoxPack: "center",
                          justifyContent: "center",
                        }}
                      >
                        <a
                          data-test="linkButton"
                          aria-label="Découvrir: La Carte Liberté, pour des déplacements professionnels éco-responsables&nbsp;!"
                          href="/article/la-carte-liberte-pour-des-deplacements-professionnels-eco-responsables"
                          target="_blank"
                          title="Découvrir - Nouvel Onglet"
                          rel="noopener noreferrer"
                          style={{
                            fontSize: "13px",
                            lineHeight: "18px",
                            boxSizing: "border-box",
                            backgroundColor: "rgba(0, 0, 0, 0)",
                            margin: "0px",
                            fontFamily:
                              "Avenir",
                            fontWeight: 500,
                            color: "rgb(20, 112, 138)",
                            textDecoration: "none solid rgb(20, 112, 138)",
                            cursor: "pointer",
                            position: "relative",
                            WebkitBoxAlign: "center",
                            alignItems: "center",
                            display: "flex",
                            padding: "15px",
                            boxShadow: "none",
                            WebkitBoxPack: "center",
                            justifyContent: "center",
                            textTransform: "none",
                          }}
                        >
                          Découvrir
                          <svg
                            aria-hidden="true"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{
                              boxSizing: "border-box",
                              height: "16px",
                              width: "1rem",
                              alignSelf: "normal",
                              fill: "rgb(20, 112, 138)",
                              flexShrink: 0,
                              marginLeft: "6px",
                            }}
                          >
                            <path
                              d="M12 0C9.62663 0 7.30655 0.703788 5.33316 2.02236C3.35977 3.34094 1.8217 5.21508 0.913451 7.4078C0.00519941 9.60051 -0.232441 12.0133 0.230582 14.3411C0.693605 16.6689 1.83649 18.807 3.51472 20.4853C5.19295 22.1635 7.33115 23.3064 9.65892 23.7694C11.9867 24.2324 14.3995 23.9948 16.5922 23.0865C18.7849 22.1783 20.6591 20.6402 21.9776 18.6668C23.2962 16.6934 24 14.3734 24 12C24 10.4241 23.6896 8.8637 23.0866 7.4078C22.4835 5.95189 21.5996 4.62902 20.4853 3.51472C19.371 2.40041 18.0481 1.5165 16.5922 0.913445C15.1363 0.310389 13.5759 0 12 0ZM16.0464 12.5177L11.4398 16.9615C11.3024 17.094 11.118 17.1666 10.9271 17.1632C10.7362 17.1598 10.5545 17.0807 10.422 16.9433C10.2894 16.806 10.2169 16.6215 10.2203 16.4307C10.2237 16.2398 10.3028 16.0581 10.4402 15.9256L14.5095 11.9998L10.4402 8.07458C10.3028 7.94203 10.2237 7.76033 10.2203 7.56946C10.2169 7.37859 10.2894 7.19419 10.422 7.05681C10.5545 6.91944 10.7362 6.84035 10.9271 6.83694C11.118 6.83354 11.3024 6.90609 11.4398 7.03865L16.0464 11.4818C16.1161 11.5489 16.1715 11.6293 16.2093 11.7183C16.2472 11.8073 16.2667 11.9031 16.2667 11.9998C16.2667 12.0965 16.2472 12.1922 16.2093 12.2812C16.1715 12.3702 16.1161 12.4507 16.0464 12.5177Z"
                              style={{ boxSizing: "border-box" }}
                            ></path>
                          </svg>
                        </a>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <hr
              aria-hidden="true"
              style={{
                boxSizing: "content-box",
                height: "8px",
                overflow: "visible",
                margin: "0px",
                flexShrink: 0,
                borderWidth: "0px",
                borderColor: "rgb(173, 255, 47)",
                backgroundColor: "rgb(255, 255, 255)",
                borderStyle: "none",
              }}
            />
            <div
              style={{
                padding: "56px 80px 32px",
                boxSizing: "border-box",
                marginBottom: "24px",
                paddingTop: "56px",
              }}
            >
              <h2
                style={{
                  fontSize: "20px",
                  lineHeight: "26px",
                  boxSizing: "border-box",
                  margin: "0px 0px 16px",
                  fontFamily: "Avenir",
                  fontWeight: 800,
                }}
              >
                Les questions fréquentes
              </h2>
              <p
                style={{
                  fontSize: "16px",
                  lineHeight: "22px",
                  boxSizing: "border-box",
                  margin: "0px 0px 32px",
                  fontFamily: "Avenir",
                  fontWeight: 500,
                }}
              >
                Vous avez une question sur la Carte Liberté ? La réponse se
                trouve probablement ci-dessous :{" "}
              </p>
              <ul
                tabIndex={0}
                data-test="description_wrapper"
                style={{
                  boxSizing: "border-box",
                  display: "flex",
                  flexDirection: "column",
                  listStyle: "outside none none",
                  margin: "0px",
                  padding: "0px",
                }}
              >
                <li style={{ boxSizing: "border-box" }}>
                  <div
                    
                    
                    
                    data-test="description_question_0"
                    style={{
                      boxSizing: "border-box",
                      borderBottomLeftRadius: "14px",
                      borderBottomRightRadius: "14px",
                      borderTopLeftRadius: "14px",
                      borderTopRightRadius: "14px",
                      color: "rgb(12, 19, 31)",
                      boxShadow: "none",
                      position: "relative",
                      transition:
                        "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                      overflowAnchor: "none",
                      borderRadius: "14px",
                      background:
                        "rgb(243, 243, 248) none repeat scroll 0% 0% / auto padding-box border-box",
                    }}
                  >
                    <div
                      tabIndex={0}
                      role="button"
                      aria-expanded="false"
                      
                      aria-controls="description_question_0-content"
                      data-test="description_question_0_summary"
                      style={{
                        boxSizing: "border-box",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        WebkitBoxPack: "center",
                        justifyContent: "center",
                        position: "relative",
                        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        outline: "rgb(12, 19, 31) none 0px",
                        border: "0px none rgb(12, 19, 31)",
                        margin: "0px",
                        borderRadius: "0px",
                        cursor: "pointer",
                        userSelect: "none",
                        verticalAlign: "middle",
                        appearance: "none",
                        textDecoration: "none solid rgb(12, 19, 31)",
                        color: "rgb(12, 19, 31)",
                        display: "flex",
                        transition:
                          "min-height 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s, background-color 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                        minHeight: "56px",
                        padding: "16px 0px",
                      }}
                    >
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          WebkitBoxFlex: 1,
                          flexGrow: 1,
                          transition:
                            "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                          margin: "0px",
                        }}
                      >
                        <div
                          style={{
                            boxSizing: "border-box",
                            WebkitBoxAlign: "center",
                            alignItems: "center",
                            display: "flex",
                            WebkitBoxFlex: 1,
                            flexGrow: 1,
                            width: "calc(100% - 34px)",
                          }}
                        >
                          <p
                            style={{
                              fontSize: "16px",
                              lineHeight: "22px",
                              boxSizing: "border-box",
                              margin: "0px",
                              fontFamily:
                                "Avenir",
                              fontWeight: 500,
                            }}
                          >
                            Qu'est-ce que le contrat pro ?
                          </p>
                        </div>
                      </div>
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          color: "rgb(12, 19, 31)",
                          transform: "matrix(1, 0, 0, 1, 0, 0)",
                          transition:
                            "transform 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                          marginRight: "-16px",
                          padding: "0px 16px",
                        }}
                      >
                        <svg
                          aria-hidden="true"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{
                            boxSizing: "border-box",
                            height: "24px",
                            width: "1.5rem",
                            color: "rgb(20, 112, 138)",
                            display: "block",
                            fill: "rgb(20, 112, 138)",
                            flexShrink: 0,
                            fontSize: "24px",
                            transition:
                              "fill 0.2s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                            userSelect: "none",
                          }}
                        >
                          <path
                            d="M17.3341 8.79362C16.9383 8.36568 16.2617 8.36568 15.8659 8.79362L12 12.973L8.1341 8.79362C7.73825 8.36568 7.06175 8.36568 6.6659 8.79362L6.62811 8.83447C6.27358 9.21775 6.27358 9.80928 6.62811 10.1926L11.2659 15.2064C11.6617 15.6343 12.3383 15.6343 12.7341 15.2064L17.3719 10.1926C17.7264 9.80928 17.7264 9.21775 17.3719 8.83447L17.3341 8.79362Z"
                            style={{ boxSizing: "border-box" }}
                          ></path>
                        </svg>
                      </div>
                    </div>
                    <div
                      style={{
                        minHeight: "0px",
                        boxSizing: "border-box",
                        height: "0px",
                        overflow: "hidden",
                        transition:
                          "height 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                        visibility: "hidden",
                      }}
                    >
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          width: "100%",
                        }}
                      >
                        <div style={{ boxSizing: "border-box", width: "100%" }}>
                          <div
                            aria-labelledby="description_question_0-summary"
                            role="region"
                            style={{ boxSizing: "border-box" }}
                          >
                            <div
                              
                              
                              
                              data-test="description_question_0_details"
                              style={{
                                boxSizing: "border-box",
                                padding: "0px",
                                flexDirection: "column",
                              }}
                            >
                              <p
                                
                                data-test="description_details_content_0"
                                style={{
                                  fontSize: "16px",
                                  lineHeight: "22px",
                                  boxSizing: "border-box",
                                  margin: "0px 0px 16px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 500,
                                  whiteSpace: "pre-line",
                                }}
                              >
                                Le Contrat Pro est une offre gratuite à
                                destination des entreprises (de la
                                micro-entreprise à la multinationale).
                                L'adhésion est très simple et se fait en
                                quelques minutes. Vous aurez besoin du numéro de
                                SIRET et du code NAF de votre entreprise. Un
                                fois votre demande d'adhésion réalisée, vous
                                recevrez un code entreprise. Vous pourrez
                                renseigner ce code dans votre compte client SNCF
                                Connect, sur votre parcours de réservation de
                                billet ou d'achat de Carte Liberté. Il vous
                                permettra d'avoir accès à plusieurs avantages :
                                - 50€ de remise immédiate sur la Carte Liberté -
                                5% de réduction toute l'année sur le tarif
                                Business Première - Accès au tarif Pro 2nde Pour
                                plus d'informations rendez-vous sur :
                                https://www.sncf-connect.com/train/pro/offres/contrat-pro
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr
                    aria-hidden="true"
                    style={{
                      boxSizing: "content-box",
                      height: "1px",
                      overflow: "visible",
                      margin: "0px",
                      flexShrink: 0,
                      borderWidth: "0px 0px 1px",
                      borderStyle: "solid",
                      borderColor: "rgb(132, 139, 155)",
                    }}
                  />
                </li>
                <li style={{ boxSizing: "border-box" }}>
                  <div
                    
                    
                    
                    data-test="description_question_1"
                    style={{
                      boxSizing: "border-box",
                      borderBottomLeftRadius: "14px",
                      borderBottomRightRadius: "14px",
                      borderTopLeftRadius: "14px",
                      borderTopRightRadius: "14px",
                      color: "rgb(12, 19, 31)",
                      boxShadow: "none",
                      position: "relative",
                      transition:
                        "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                      overflowAnchor: "none",
                      borderRadius: "14px",
                      background:
                        "rgb(243, 243, 248) none repeat scroll 0% 0% / auto padding-box border-box",
                    }}
                  >
                    <div
                      tabIndex={0}
                      role="button"
                      aria-expanded="false"
                      
                      aria-controls="description_question_1-content"
                      data-test="description_question_1_summary"
                      style={{
                        boxSizing: "border-box",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        WebkitBoxPack: "center",
                        justifyContent: "center",
                        position: "relative",
                        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        outline: "rgb(12, 19, 31) none 0px",
                        border: "0px none rgb(12, 19, 31)",
                        margin: "0px",
                        borderRadius: "0px",
                        cursor: "pointer",
                        userSelect: "none",
                        verticalAlign: "middle",
                        appearance: "none",
                        textDecoration: "none solid rgb(12, 19, 31)",
                        color: "rgb(12, 19, 31)",
                        display: "flex",
                        transition:
                          "min-height 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s, background-color 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                        minHeight: "56px",
                        padding: "16px 0px",
                      }}
                    >
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          WebkitBoxFlex: 1,
                          flexGrow: 1,
                          transition:
                            "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                          margin: "0px",
                        }}
                      >
                        <div
                          style={{
                            boxSizing: "border-box",
                            WebkitBoxAlign: "center",
                            alignItems: "center",
                            display: "flex",
                            WebkitBoxFlex: 1,
                            flexGrow: 1,
                            width: "calc(100% - 34px)",
                          }}
                        >
                          <p
                            style={{
                              fontSize: "16px",
                              lineHeight: "22px",
                              boxSizing: "border-box",
                              margin: "0px",
                              fontFamily:
                                "Avenir",
                              fontWeight: 500,
                            }}
                          >
                            Que signifie billet 100% flexible ?
                          </p>
                        </div>
                      </div>
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          color: "rgb(12, 19, 31)",
                          transform: "matrix(1, 0, 0, 1, 0, 0)",
                          transition:
                            "transform 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                          marginRight: "-16px",
                          padding: "0px 16px",
                        }}
                      >
                        <svg
                          aria-hidden="true"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{
                            boxSizing: "border-box",
                            height: "24px",
                            width: "1.5rem",
                            color: "rgb(20, 112, 138)",
                            display: "block",
                            fill: "rgb(20, 112, 138)",
                            flexShrink: 0,
                            fontSize: "24px",
                            transition:
                              "fill 0.2s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                            userSelect: "none",
                          }}
                        >
                          <path
                            d="M17.3341 8.79362C16.9383 8.36568 16.2617 8.36568 15.8659 8.79362L12 12.973L8.1341 8.79362C7.73825 8.36568 7.06175 8.36568 6.6659 8.79362L6.62811 8.83447C6.27358 9.21775 6.27358 9.80928 6.62811 10.1926L11.2659 15.2064C11.6617 15.6343 12.3383 15.6343 12.7341 15.2064L17.3719 10.1926C17.7264 9.80928 17.7264 9.21775 17.3719 8.83447L17.3341 8.79362Z"
                            style={{ boxSizing: "border-box" }}
                          ></path>
                        </svg>
                      </div>
                    </div>
                    <div
                      style={{
                        minHeight: "0px",
                        boxSizing: "border-box",
                        height: "0px",
                        overflow: "hidden",
                        transition:
                          "height 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                        visibility: "hidden",
                      }}
                    >
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          width: "100%",
                        }}
                      >
                        <div style={{ boxSizing: "border-box", width: "100%" }}>
                          <div
                            aria-labelledby="description_question_1-summary"
                            role="region"
                            style={{ boxSizing: "border-box" }}
                          >
                            <div
                              
                              
                              
                              data-test="description_question_1_details"
                              style={{
                                boxSizing: "border-box",
                                padding: "0px",
                                flexDirection: "column",
                              }}
                            >
                              <p
                                
                                data-test="description_details_content_1"
                                style={{
                                  fontSize: "16px",
                                  lineHeight: "22px",
                                  boxSizing: "border-box",
                                  margin: "0px 0px 16px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 500,
                                  whiteSpace: "pre-line",
                                }}
                              >
                                Un billet 100% flexible est échangeable et
                                remboursable sans frais jusqu'à 30 minutes après
                                le départ du train en mobilité via l'application
                                SNCF Connect ou TGV INOUI Pro et en gare de
                                départ. À partir de 30 minutes avant le départ
                                du train, le billet est échangeable 2 fois
                                maximum uniquement pour le même jour et le même
                                trajet et non remboursable après échange. Pour
                                emprunter un autre train, l'échange du billet
                                est obligatoire et peut se faire facilement sur
                                l'application SNCF Connect à tout moment dans
                                les conditions citées ci-dessus.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr
                    aria-hidden="true"
                    style={{
                      boxSizing: "content-box",
                      height: "1px",
                      overflow: "visible",
                      margin: "0px",
                      flexShrink: 0,
                      borderWidth: "0px 0px 1px",
                      borderStyle: "solid",
                      borderColor: "rgb(132, 139, 155)",
                    }}
                  />
                </li>
                <li style={{ boxSizing: "border-box" }}>
                  <div
                    
                    
                    
                    data-test="description_question_2"
                    style={{
                      boxSizing: "border-box",
                      borderBottomLeftRadius: "14px",
                      borderBottomRightRadius: "14px",
                      borderTopLeftRadius: "14px",
                      borderTopRightRadius: "14px",
                      color: "rgb(12, 19, 31)",
                      boxShadow: "none",
                      position: "relative",
                      transition:
                        "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                      overflowAnchor: "none",
                      borderRadius: "14px",
                      background:
                        "rgb(243, 243, 248) none repeat scroll 0% 0% / auto padding-box border-box",
                    }}
                  >
                    <div
                      tabIndex={0}
                      role="button"
                      aria-expanded="false"
                      
                      aria-controls="description_question_2-content"
                      data-test="description_question_2_summary"
                      style={{
                        boxSizing: "border-box",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        WebkitBoxPack: "center",
                        justifyContent: "center",
                        position: "relative",
                        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        outline: "rgb(12, 19, 31) none 0px",
                        border: "0px none rgb(12, 19, 31)",
                        margin: "0px",
                        borderRadius: "0px",
                        cursor: "pointer",
                        userSelect: "none",
                        verticalAlign: "middle",
                        appearance: "none",
                        textDecoration: "none solid rgb(12, 19, 31)",
                        color: "rgb(12, 19, 31)",
                        display: "flex",
                        transition:
                          "min-height 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s, background-color 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                        minHeight: "56px",
                        padding: "16px 0px",
                      }}
                    >
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          WebkitBoxFlex: 1,
                          flexGrow: 1,
                          transition:
                            "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                          margin: "0px",
                        }}
                      >
                        <div
                          style={{
                            boxSizing: "border-box",
                            WebkitBoxAlign: "center",
                            alignItems: "center",
                            display: "flex",
                            WebkitBoxFlex: 1,
                            flexGrow: 1,
                            width: "calc(100% - 34px)",
                          }}
                        >
                          <p
                            style={{
                              fontSize: "16px",
                              lineHeight: "22px",
                              boxSizing: "border-box",
                              margin: "0px",
                              fontFamily:
                                "Avenir",
                              fontWeight: 500,
                            }}
                          >
                            La Carte Liberté propose des tarifs Liberté fixes,
                            qu’est-ce que cela signifie ?
                          </p>
                        </div>
                      </div>
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          color: "rgb(12, 19, 31)",
                          transform: "matrix(1, 0, 0, 1, 0, 0)",
                          transition:
                            "transform 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                          marginRight: "-16px",
                          padding: "0px 16px",
                        }}
                      >
                        <svg
                          aria-hidden="true"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{
                            boxSizing: "border-box",
                            height: "24px",
                            width: "1.5rem",
                            color: "rgb(20, 112, 138)",
                            display: "block",
                            fill: "rgb(20, 112, 138)",
                            flexShrink: 0,
                            fontSize: "24px",
                            transition:
                              "fill 0.2s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                            userSelect: "none",
                          }}
                        >
                          <path
                            d="M17.3341 8.79362C16.9383 8.36568 16.2617 8.36568 15.8659 8.79362L12 12.973L8.1341 8.79362C7.73825 8.36568 7.06175 8.36568 6.6659 8.79362L6.62811 8.83447C6.27358 9.21775 6.27358 9.80928 6.62811 10.1926L11.2659 15.2064C11.6617 15.6343 12.3383 15.6343 12.7341 15.2064L17.3719 10.1926C17.7264 9.80928 17.7264 9.21775 17.3719 8.83447L17.3341 8.79362Z"
                            style={{ boxSizing: "border-box" }}
                          ></path>
                        </svg>
                      </div>
                    </div>
                    <div
                      style={{
                        minHeight: "0px",
                        boxSizing: "border-box",
                        height: "0px",
                        overflow: "hidden",
                        transition:
                          "height 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                        visibility: "hidden",
                      }}
                    >
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          width: "100%",
                        }}
                      >
                        <div style={{ boxSizing: "border-box", width: "100%" }}>
                          <div
                            aria-labelledby="description_question_2-summary"
                            role="region"
                            style={{ boxSizing: "border-box" }}
                          >
                            <div
                              
                              
                              
                              data-test="description_question_2_details"
                              style={{
                                boxSizing: "border-box",
                                padding: "0px",
                                flexDirection: "column",
                              }}
                            >
                              <p
                                
                                data-test="description_details_content_2"
                                style={{
                                  fontSize: "16px",
                                  lineHeight: "22px",
                                  boxSizing: "border-box",
                                  margin: "0px 0px 16px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 500,
                                  whiteSpace: "pre-line",
                                }}
                              >
                                Initialement, les prix des billets varient en
                                fonction du taux de remplissage du train et de
                                la date de réservation. Souvent en dernières
                                minutes, les billets de train sont plus chers.
                                Mais pas avec le tarif Liberté ! Le tarif
                                Liberté ne varie pas, il est fixe toute l'année,
                                même en dernière minute (le billet lui est
                                toujours 100% flexible). Quelques exemples de
                                prix fixes par destination en 2nde classe TGV
                                INOUI : &gt; Paris - Lyon 62€ &gt; Paris -
                                Marseille 71€ &gt; Paris - Bordeaux 75€ &gt;
                                Paris - Nantes 58€ &gt; Paris - Strasbourg 66€
                                &gt; Paris - Rennes 58€ &gt; Pairs - Montpellier
                                70€ &gt; Paris - Lille 37€
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr
                    aria-hidden="true"
                    style={{
                      boxSizing: "content-box",
                      height: "1px",
                      overflow: "visible",
                      margin: "0px",
                      flexShrink: 0,
                      borderWidth: "0px 0px 1px",
                      borderStyle: "solid",
                      borderColor: "rgb(132, 139, 155)",
                    }}
                  />
                </li>
                <li style={{ boxSizing: "border-box" }}>
                  <div
                    
                    
                    
                    data-test="description_question_3"
                    style={{
                      boxSizing: "border-box",
                      borderBottomLeftRadius: "14px",
                      borderBottomRightRadius: "14px",
                      borderTopLeftRadius: "14px",
                      borderTopRightRadius: "14px",
                      color: "rgb(12, 19, 31)",
                      boxShadow: "none",
                      position: "relative",
                      transition:
                        "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                      overflowAnchor: "none",
                      borderRadius: "14px",
                      background:
                        "rgb(243, 243, 248) none repeat scroll 0% 0% / auto padding-box border-box",
                    }}
                  >
                    <div
                      tabIndex={0}
                      role="button"
                      aria-expanded="false"
                      
                      aria-controls="description_question_3-content"
                      data-test="description_question_3_summary"
                      style={{
                        boxSizing: "border-box",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        WebkitBoxPack: "center",
                        justifyContent: "center",
                        position: "relative",
                        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        outline: "rgb(12, 19, 31) none 0px",
                        border: "0px none rgb(12, 19, 31)",
                        margin: "0px",
                        borderRadius: "0px",
                        cursor: "pointer",
                        userSelect: "none",
                        verticalAlign: "middle",
                        appearance: "none",
                        textDecoration: "none solid rgb(12, 19, 31)",
                        color: "rgb(12, 19, 31)",
                        display: "flex",
                        transition:
                          "min-height 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s, background-color 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                        minHeight: "56px",
                        padding: "16px 0px",
                      }}
                    >
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          WebkitBoxFlex: 1,
                          flexGrow: 1,
                          transition:
                            "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                          margin: "0px",
                        }}
                      >
                        <div
                          style={{
                            boxSizing: "border-box",
                            WebkitBoxAlign: "center",
                            alignItems: "center",
                            display: "flex",
                            WebkitBoxFlex: 1,
                            flexGrow: 1,
                            width: "calc(100% - 34px)",
                          }}
                        >
                          <p
                            style={{
                              fontSize: "16px",
                              lineHeight: "22px",
                              boxSizing: "border-box",
                              margin: "0px",
                              fontFamily:
                                "Avenir",
                              fontWeight: 500,
                            }}
                          >
                            Comment avoir accès au programme de fidélité Grand
                            Voyageur ?
                          </p>
                        </div>
                      </div>
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          color: "rgb(12, 19, 31)",
                          transform: "matrix(1, 0, 0, 1, 0, 0)",
                          transition:
                            "transform 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                          marginRight: "-16px",
                          padding: "0px 16px",
                        }}
                      >
                        <svg
                          aria-hidden="true"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{
                            boxSizing: "border-box",
                            height: "24px",
                            width: "1.5rem",
                            color: "rgb(20, 112, 138)",
                            display: "block",
                            fill: "rgb(20, 112, 138)",
                            flexShrink: 0,
                            fontSize: "24px",
                            transition:
                              "fill 0.2s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                            userSelect: "none",
                          }}
                        >
                          <path
                            d="M17.3341 8.79362C16.9383 8.36568 16.2617 8.36568 15.8659 8.79362L12 12.973L8.1341 8.79362C7.73825 8.36568 7.06175 8.36568 6.6659 8.79362L6.62811 8.83447C6.27358 9.21775 6.27358 9.80928 6.62811 10.1926L11.2659 15.2064C11.6617 15.6343 12.3383 15.6343 12.7341 15.2064L17.3719 10.1926C17.7264 9.80928 17.7264 9.21775 17.3719 8.83447L17.3341 8.79362Z"
                            style={{ boxSizing: "border-box" }}
                          ></path>
                        </svg>
                      </div>
                    </div>
                    <div
                      style={{
                        minHeight: "0px",
                        boxSizing: "border-box",
                        height: "0px",
                        overflow: "hidden",
                        transition:
                          "height 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                        visibility: "hidden",
                      }}
                    >
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          width: "100%",
                        }}
                      >
                        <div style={{ boxSizing: "border-box", width: "100%" }}>
                          <div
                            aria-labelledby="description_question_3-summary"
                            role="region"
                            style={{ boxSizing: "border-box" }}
                          >
                            <div
                              
                              
                              
                              data-test="description_question_3_details"
                              style={{
                                boxSizing: "border-box",
                                padding: "0px",
                                flexDirection: "column",
                              }}
                            >
                              <p
                                
                                data-test="description_details_content_3"
                                style={{
                                  fontSize: "16px",
                                  lineHeight: "22px",
                                  boxSizing: "border-box",
                                  margin: "0px 0px 16px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 500,
                                  whiteSpace: "pre-line",
                                }}
                              >
                                Depuis le 29 février 2024, l'achat d'une carte
                                Liberté TGV INOUI permet d'accéder au programme
                                de fidélité Grand Voyageur proposé par SNCF
                                Voyageurs. Lors de l'activation de votre carte
                                Liberté, vous recevez automatiquement une
                                invitation par mail pour devenir membre du
                                programme. Le programme de fidélité Grand
                                Voyageur vous permettra de cumuler des points
                                sur les trajets supérieurs à 9€ réalisés en
                                France sur TGV INOUI et Intercités (hors TER,
                                Transilien, OUIGO Grande Vitesse et Ligne
                                Classique) et sur les trajets internationaux
                                (retrouvez la liste des trajets sur
                                TGVINOUI.sncf). Les Points Prime peuvent être
                                cumulés sur l’achat de Carte Avantage, carte
                                Liberté, Forfait Ligne Grande Vitesse,
                                abonnement MAX et la commande en ligne du Bar
                                TGV INOUI. L’adhésion au programme est gratuite
                                et non obligatoire. En cas de renouvellement de
                                la Carte Liberté TGV INOUI, l’adhésion au
                                programme est maintenue.Si la carte n’est pas
                                renouvelée, le client peut perdre son statut
                                Grand Voyageur selon les Conditions Générales
                                d’Utilisation du programme
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr
                    aria-hidden="true"
                    style={{
                      boxSizing: "content-box",
                      height: "1px",
                      overflow: "visible",
                      margin: "0px",
                      flexShrink: 0,
                      borderWidth: "0px 0px 1px",
                      borderStyle: "solid",
                      borderColor: "rgb(132, 139, 155)",
                    }}
                  />
                </li>
                <li style={{ boxSizing: "border-box" }}>
                  <div
                    
                    
                    
                    data-test="description_question_4"
                    style={{
                      boxSizing: "border-box",
                      borderBottomLeftRadius: "14px",
                      borderBottomRightRadius: "14px",
                      borderTopLeftRadius: "14px",
                      borderTopRightRadius: "14px",
                      color: "rgb(12, 19, 31)",
                      boxShadow: "none",
                      position: "relative",
                      transition:
                        "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                      overflowAnchor: "none",
                      borderRadius: "14px",
                      background:
                        "rgb(243, 243, 248) none repeat scroll 0% 0% / auto padding-box border-box",
                    }}
                  >
                    <div
                      tabIndex={0}
                      role="button"
                      aria-expanded="false"
                      
                      aria-controls="description_question_4-content"
                      data-test="description_question_4_summary"
                      style={{
                        boxSizing: "border-box",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        WebkitBoxPack: "center",
                        justifyContent: "center",
                        position: "relative",
                        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        outline: "rgb(12, 19, 31) none 0px",
                        border: "0px none rgb(12, 19, 31)",
                        margin: "0px",
                        borderRadius: "0px",
                        cursor: "pointer",
                        userSelect: "none",
                        verticalAlign: "middle",
                        appearance: "none",
                        textDecoration: "none solid rgb(12, 19, 31)",
                        color: "rgb(12, 19, 31)",
                        display: "flex",
                        transition:
                          "min-height 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s, background-color 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                        minHeight: "56px",
                        padding: "16px 0px",
                      }}
                    >
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          WebkitBoxFlex: 1,
                          flexGrow: 1,
                          transition:
                            "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                          margin: "0px",
                        }}
                      >
                        <div
                          style={{
                            boxSizing: "border-box",
                            WebkitBoxAlign: "center",
                            alignItems: "center",
                            display: "flex",
                            WebkitBoxFlex: 1,
                            flexGrow: 1,
                            width: "calc(100% - 34px)",
                          }}
                        >
                          <p
                            style={{
                              fontSize: "16px",
                              lineHeight: "22px",
                              boxSizing: "border-box",
                              margin: "0px",
                              fontFamily:
                                "Avenir",
                              fontWeight: 500,
                            }}
                          >
                            La Carte Liberté fonctionne-t-elle pour les voyages
                            en Europe ?
                          </p>
                        </div>
                      </div>
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          color: "rgb(12, 19, 31)",
                          transform: "matrix(1, 0, 0, 1, 0, 0)",
                          transition:
                            "transform 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                          marginRight: "-16px",
                          padding: "0px 16px",
                        }}
                      >
                        <svg
                          aria-hidden="true"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{
                            boxSizing: "border-box",
                            height: "24px",
                            width: "1.5rem",
                            color: "rgb(20, 112, 138)",
                            display: "block",
                            fill: "rgb(20, 112, 138)",
                            flexShrink: 0,
                            fontSize: "24px",
                            transition:
                              "fill 0.2s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                            userSelect: "none",
                          }}
                        >
                          <path
                            d="M17.3341 8.79362C16.9383 8.36568 16.2617 8.36568 15.8659 8.79362L12 12.973L8.1341 8.79362C7.73825 8.36568 7.06175 8.36568 6.6659 8.79362L6.62811 8.83447C6.27358 9.21775 6.27358 9.80928 6.62811 10.1926L11.2659 15.2064C11.6617 15.6343 12.3383 15.6343 12.7341 15.2064L17.3719 10.1926C17.7264 9.80928 17.7264 9.21775 17.3719 8.83447L17.3341 8.79362Z"
                            style={{ boxSizing: "border-box" }}
                          ></path>
                        </svg>
                      </div>
                    </div>
                    <div
                      style={{
                        minHeight: "0px",
                        boxSizing: "border-box",
                        height: "0px",
                        overflow: "hidden",
                        transition:
                          "height 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                        visibility: "hidden",
                      }}
                    >
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          width: "100%",
                        }}
                      >
                        <div style={{ boxSizing: "border-box", width: "100%" }}>
                          <div
                            aria-labelledby="description_question_4-summary"
                            role="region"
                            style={{ boxSizing: "border-box" }}
                          >
                            <div
                              
                              
                              
                              data-test="description_question_4_details"
                              style={{
                                boxSizing: "border-box",
                                padding: "0px",
                                flexDirection: "column",
                              }}
                            >
                              <p
                                
                                data-test="description_details_content_4"
                                style={{
                                  fontSize: "16px",
                                  lineHeight: "22px",
                                  boxSizing: "border-box",
                                  margin: "0px 0px 16px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 500,
                                  whiteSpace: "pre-line",
                                }}
                              >
                                Votre Carte Liberté fonctionne pour certains
                                voyages en Europe ! Avec le tarif Liberté : Vers
                                le Luxembourg, l'Italie et l'Espagne avec TGV
                                INOUI aux mêmes conditions qu'en France : o -60%
                                en 2nde Flexible sur la base sur tarif Business
                                Première ; o -45% en Business Première sur la
                                base du tarif Business Première. Vers
                                l'Allemagne avec TGV INOUI et DB-SNCF en
                                Coopération aux mêmes conditions qu'en France :
                                o -60% en 2nde Flexible sur la base sur tarif
                                Business Première ; o -45% en Business Première
                                sur la base du tarif Business Première. Vers la
                                Suisse avec TGV Lyria aux conditions suivantes :
                                o -40% en BUSINESS 1ERE par rapport au plein
                                tarif BUSINESS 1ERE o -45% en STANDARD 1ERE par
                                rapport au plein tarif BUSINESS 1ERE le samedi o
                                -60% en STANDARD par rapport au plein tarif
                                STANDARD 1ERE. Avec le tarif Avantage : o -30%
                                sur vos voyages : o Vers le Luxembourg, l'Italie
                                avec TGV INOUI o Vers l'Allemagne avec TGV INOUI
                                et DB SNCF en coopération o Vers la Suisse avec
                                TGV Lyria Attention : La Carte Liberté
                                s'applique également de ces pays vers la France
                                (sous les conditions cités ci-dessus). Si vous
                                êtes résident Européen hors France, l'envoi de
                                la Carte Liberté s'effectue par voie postale. La
                                Carte Liberté n’est pas acceptée sur le
                                périmètre Renfe, même avec le tarif Avantage.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr
                    aria-hidden="true"
                    style={{
                      boxSizing: "content-box",
                      height: "1px",
                      overflow: "visible",
                      margin: "0px",
                      flexShrink: 0,
                      borderWidth: "0px 0px 1px",
                      borderStyle: "solid",
                      borderColor: "rgb(132, 139, 155)",
                    }}
                  />
                </li>
                <li style={{ boxSizing: "border-box" }}>
                  <div
                    
                    
                    
                    data-test="description_question_5"
                    style={{
                      boxSizing: "border-box",
                      borderBottomLeftRadius: "14px",
                      borderBottomRightRadius: "14px",
                      borderTopLeftRadius: "14px",
                      borderTopRightRadius: "14px",
                      color: "rgb(12, 19, 31)",
                      boxShadow: "none",
                      position: "relative",
                      transition:
                        "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                      overflowAnchor: "none",
                      borderRadius: "14px",
                      background:
                        "rgb(243, 243, 248) none repeat scroll 0% 0% / auto padding-box border-box",
                    }}
                  >
                    <div
                      tabIndex={0}
                      role="button"
                      aria-expanded="false"
                      
                      aria-controls="description_question_5-content"
                      data-test="description_question_5_summary"
                      style={{
                        boxSizing: "border-box",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        WebkitBoxPack: "center",
                        justifyContent: "center",
                        position: "relative",
                        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        outline: "rgb(12, 19, 31) none 0px",
                        border: "0px none rgb(12, 19, 31)",
                        margin: "0px",
                        borderRadius: "0px",
                        cursor: "pointer",
                        userSelect: "none",
                        verticalAlign: "middle",
                        appearance: "none",
                        textDecoration: "none solid rgb(12, 19, 31)",
                        color: "rgb(12, 19, 31)",
                        display: "flex",
                        transition:
                          "min-height 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s, background-color 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                        minHeight: "56px",
                        padding: "16px 0px",
                      }}
                    >
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          WebkitBoxFlex: 1,
                          flexGrow: 1,
                          transition:
                            "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                          margin: "0px",
                        }}
                      >
                        <div
                          style={{
                            boxSizing: "border-box",
                            WebkitBoxAlign: "center",
                            alignItems: "center",
                            display: "flex",
                            WebkitBoxFlex: 1,
                            flexGrow: 1,
                            width: "calc(100% - 34px)",
                          }}
                        >
                          <p
                            style={{
                              fontSize: "16px",
                              lineHeight: "22px",
                              boxSizing: "border-box",
                              margin: "0px",
                              fontFamily:
                                "Avenir",
                              fontWeight: 500,
                            }}
                          >
                            La Carte Liberté fonctionne-t-elle pour les voyages
                            en TER ?{" "}
                          </p>
                        </div>
                      </div>
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          color: "rgb(12, 19, 31)",
                          transform: "matrix(1, 0, 0, 1, 0, 0)",
                          transition:
                            "transform 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                          marginRight: "-16px",
                          padding: "0px 16px",
                        }}
                      >
                        <svg
                          aria-hidden="true"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{
                            boxSizing: "border-box",
                            height: "24px",
                            width: "1.5rem",
                            color: "rgb(20, 112, 138)",
                            display: "block",
                            fill: "rgb(20, 112, 138)",
                            flexShrink: 0,
                            fontSize: "24px",
                            transition:
                              "fill 0.2s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                            userSelect: "none",
                          }}
                        >
                          <path
                            d="M17.3341 8.79362C16.9383 8.36568 16.2617 8.36568 15.8659 8.79362L12 12.973L8.1341 8.79362C7.73825 8.36568 7.06175 8.36568 6.6659 8.79362L6.62811 8.83447C6.27358 9.21775 6.27358 9.80928 6.62811 10.1926L11.2659 15.2064C11.6617 15.6343 12.3383 15.6343 12.7341 15.2064L17.3719 10.1926C17.7264 9.80928 17.7264 9.21775 17.3719 8.83447L17.3341 8.79362Z"
                            style={{ boxSizing: "border-box" }}
                          ></path>
                        </svg>
                      </div>
                    </div>
                    <div
                      style={{
                        minHeight: "0px",
                        boxSizing: "border-box",
                        height: "0px",
                        overflow: "hidden",
                        transition:
                          "height 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                        visibility: "hidden",
                      }}
                    >
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          width: "100%",
                        }}
                      >
                        <div style={{ boxSizing: "border-box", width: "100%" }}>
                          <div
                            aria-labelledby="description_question_5-summary"
                            role="region"
                            style={{ boxSizing: "border-box" }}
                          >
                            <div
                              
                              
                              
                              data-test="description_question_5_details"
                              style={{
                                boxSizing: "border-box",
                                padding: "0px",
                                flexDirection: "column",
                              }}
                            >
                              <p
                                
                                data-test="description_details_content_5"
                                style={{
                                  fontSize: "16px",
                                  lineHeight: "22px",
                                  boxSizing: "border-box",
                                  margin: "0px 0px 16px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 500,
                                  whiteSpace: "pre-line",
                                }}
                              >
                                Avec la Carte Liberté vous pouvez avoir jusqu'à
                                50% de réduction sur les billets TER. La
                                disponibilité des remises dépend des autorités
                                organisatrices régionales. Retrouvez les
                                montants des remises sur
                                https://www.sncf-voyageurs.com/medias-publics/2023-12/reduction-ter-carte-liberte.pdf
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr
                    aria-hidden="true"
                    style={{
                      boxSizing: "content-box",
                      height: "1px",
                      overflow: "visible",
                      margin: "0px",
                      flexShrink: 0,
                      borderWidth: "0px 0px 1px",
                      borderStyle: "solid",
                      borderColor: "rgb(132, 139, 155)",
                    }}
                  />
                </li>
                <li style={{ boxSizing: "border-box" }}>
                  <div
                    
                    
                    
                    data-test="description_question_6"
                    style={{
                      boxSizing: "border-box",
                      borderBottomLeftRadius: "14px",
                      borderBottomRightRadius: "14px",
                      borderTopLeftRadius: "14px",
                      borderTopRightRadius: "14px",
                      color: "rgb(12, 19, 31)",
                      boxShadow: "none",
                      position: "relative",
                      transition:
                        "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                      overflowAnchor: "none",
                      borderRadius: "14px",
                      background:
                        "rgb(243, 243, 248) none repeat scroll 0% 0% / auto padding-box border-box",
                    }}
                  >
                    <div
                      tabIndex={0}
                      role="button"
                      aria-expanded="false"
                      
                      aria-controls="description_question_6-content"
                      data-test="description_question_6_summary"
                      style={{
                        boxSizing: "border-box",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        WebkitBoxPack: "center",
                        justifyContent: "center",
                        position: "relative",
                        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        outline: "rgb(12, 19, 31) none 0px",
                        border: "0px none rgb(12, 19, 31)",
                        margin: "0px",
                        borderRadius: "0px",
                        cursor: "pointer",
                        userSelect: "none",
                        verticalAlign: "middle",
                        appearance: "none",
                        textDecoration: "none solid rgb(12, 19, 31)",
                        color: "rgb(12, 19, 31)",
                        display: "flex",
                        transition:
                          "min-height 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s, background-color 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                        minHeight: "56px",
                        padding: "16px 0px",
                      }}
                    >
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          WebkitBoxFlex: 1,
                          flexGrow: 1,
                          transition:
                            "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                          margin: "0px",
                        }}
                      >
                        <div
                          style={{
                            boxSizing: "border-box",
                            WebkitBoxAlign: "center",
                            alignItems: "center",
                            display: "flex",
                            WebkitBoxFlex: 1,
                            flexGrow: 1,
                            width: "calc(100% - 34px)",
                          }}
                        >
                          <p
                            style={{
                              fontSize: "16px",
                              lineHeight: "22px",
                              boxSizing: "border-box",
                              margin: "0px",
                              fontFamily:
                                "Avenir",
                              fontWeight: 500,
                            }}
                          >
                            Quelle est la différence entre un voyage Pro et un
                            voyage Loisir ?
                          </p>
                        </div>
                      </div>
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          color: "rgb(12, 19, 31)",
                          transform: "matrix(1, 0, 0, 1, 0, 0)",
                          transition:
                            "transform 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                          marginRight: "-16px",
                          padding: "0px 16px",
                        }}
                      >
                        <svg
                          aria-hidden="true"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{
                            boxSizing: "border-box",
                            height: "24px",
                            width: "1.5rem",
                            color: "rgb(20, 112, 138)",
                            display: "block",
                            fill: "rgb(20, 112, 138)",
                            flexShrink: 0,
                            fontSize: "24px",
                            transition:
                              "fill 0.2s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                            userSelect: "none",
                          }}
                        >
                          <path
                            d="M17.3341 8.79362C16.9383 8.36568 16.2617 8.36568 15.8659 8.79362L12 12.973L8.1341 8.79362C7.73825 8.36568 7.06175 8.36568 6.6659 8.79362L6.62811 8.83447C6.27358 9.21775 6.27358 9.80928 6.62811 10.1926L11.2659 15.2064C11.6617 15.6343 12.3383 15.6343 12.7341 15.2064L17.3719 10.1926C17.7264 9.80928 17.7264 9.21775 17.3719 8.83447L17.3341 8.79362Z"
                            style={{ boxSizing: "border-box" }}
                          ></path>
                        </svg>
                      </div>
                    </div>
                    <div
                      style={{
                        minHeight: "0px",
                        boxSizing: "border-box",
                        height: "0px",
                        overflow: "hidden",
                        transition:
                          "height 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                        visibility: "hidden",
                      }}
                    >
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          width: "100%",
                        }}
                      >
                        <div style={{ boxSizing: "border-box", width: "100%" }}>
                          <div
                            aria-labelledby="description_question_6-summary"
                            role="region"
                            style={{ boxSizing: "border-box" }}
                          >
                            <div
                              
                              
                              
                              data-test="description_question_6_details"
                              style={{
                                boxSizing: "border-box",
                                padding: "0px",
                                flexDirection: "column",
                              }}
                            >
                              <p
                                
                                data-test="description_details_content_6"
                                style={{
                                  fontSize: "16px",
                                  lineHeight: "22px",
                                  boxSizing: "border-box",
                                  margin: "0px 0px 16px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 500,
                                  whiteSpace: "pre-line",
                                }}
                              >
                                Un voyage pour motif professionnel est un
                                déplacement réalisé dans le cadre du travail
                                (réunions, formations, rendez-vous...). Un
                                voyage pour motif loisir est un déplacement
                                réalisé à titre personnel dans un objectif
                                d’activités autres que professionnelles
                                (vacances, week-ends, ponts, évènements
                                personnels).
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr
                    aria-hidden="true"
                    style={{
                      boxSizing: "content-box",
                      height: "1px",
                      overflow: "visible",
                      margin: "0px",
                      flexShrink: 0,
                      borderWidth: "0px 0px 1px",
                      borderStyle: "solid",
                      borderColor: "rgb(132, 139, 155)",
                    }}
                  />
                </li>
                <li style={{ boxSizing: "border-box" }}>
                  <div
                    
                    
                    
                    data-test="description_question_7"
                    style={{
                      boxSizing: "border-box",
                      borderBottomLeftRadius: "14px",
                      borderBottomRightRadius: "14px",
                      borderTopLeftRadius: "14px",
                      borderTopRightRadius: "14px",
                      color: "rgb(12, 19, 31)",
                      boxShadow: "none",
                      position: "relative",
                      transition:
                        "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                      overflowAnchor: "none",
                      borderRadius: "14px",
                      background:
                        "rgb(243, 243, 248) none repeat scroll 0% 0% / auto padding-box border-box",
                    }}
                  >
                    <div
                      tabIndex={0}
                      role="button"
                      aria-expanded="false"
                      
                      aria-controls="description_question_7-content"
                      data-test="description_question_7_summary"
                      style={{
                        boxSizing: "border-box",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        WebkitBoxPack: "center",
                        justifyContent: "center",
                        position: "relative",
                        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        outline: "rgb(12, 19, 31) none 0px",
                        border: "0px none rgb(12, 19, 31)",
                        margin: "0px",
                        borderRadius: "0px",
                        cursor: "pointer",
                        userSelect: "none",
                        verticalAlign: "middle",
                        appearance: "none",
                        textDecoration: "none solid rgb(12, 19, 31)",
                        color: "rgb(12, 19, 31)",
                        display: "flex",
                        transition:
                          "min-height 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s, background-color 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                        minHeight: "56px",
                        padding: "16px 0px",
                      }}
                    >
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          WebkitBoxFlex: 1,
                          flexGrow: 1,
                          transition:
                            "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                          margin: "0px",
                        }}
                      >
                        <div
                          style={{
                            boxSizing: "border-box",
                            WebkitBoxAlign: "center",
                            alignItems: "center",
                            display: "flex",
                            WebkitBoxFlex: 1,
                            flexGrow: 1,
                            width: "calc(100% - 34px)",
                          }}
                        >
                          <p
                            style={{
                              fontSize: "16px",
                              lineHeight: "22px",
                              boxSizing: "border-box",
                              margin: "0px",
                              fontFamily:
                                "Avenir",
                              fontWeight: 500,
                            }}
                          >
                            Comment échanger ou annuler mon billet 100% flexible
                            (tarif Liberté) ?
                          </p>
                        </div>
                      </div>
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          color: "rgb(12, 19, 31)",
                          transform: "matrix(1, 0, 0, 1, 0, 0)",
                          transition:
                            "transform 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                          marginRight: "-16px",
                          padding: "0px 16px",
                        }}
                      >
                        <svg
                          aria-hidden="true"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{
                            boxSizing: "border-box",
                            height: "24px",
                            width: "1.5rem",
                            color: "rgb(20, 112, 138)",
                            display: "block",
                            fill: "rgb(20, 112, 138)",
                            flexShrink: 0,
                            fontSize: "24px",
                            transition:
                              "fill 0.2s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                            userSelect: "none",
                          }}
                        >
                          <path
                            d="M17.3341 8.79362C16.9383 8.36568 16.2617 8.36568 15.8659 8.79362L12 12.973L8.1341 8.79362C7.73825 8.36568 7.06175 8.36568 6.6659 8.79362L6.62811 8.83447C6.27358 9.21775 6.27358 9.80928 6.62811 10.1926L11.2659 15.2064C11.6617 15.6343 12.3383 15.6343 12.7341 15.2064L17.3719 10.1926C17.7264 9.80928 17.7264 9.21775 17.3719 8.83447L17.3341 8.79362Z"
                            style={{ boxSizing: "border-box" }}
                          ></path>
                        </svg>
                      </div>
                    </div>
                    <div
                      style={{
                        minHeight: "0px",
                        boxSizing: "border-box",
                        height: "0px",
                        overflow: "hidden",
                        transition:
                          "height 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                        visibility: "hidden",
                      }}
                    >
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          width: "100%",
                        }}
                      >
                        <div style={{ boxSizing: "border-box", width: "100%" }}>
                          <div
                            aria-labelledby="description_question_7-summary"
                            role="region"
                            style={{ boxSizing: "border-box" }}
                          >
                            <div
                              
                              
                              
                              data-test="description_question_7_details"
                              style={{
                                boxSizing: "border-box",
                                padding: "0px",
                                flexDirection: "column",
                              }}
                            >
                              <p
                                
                                data-test="description_details_content_7"
                                style={{
                                  fontSize: "16px",
                                  lineHeight: "22px",
                                  boxSizing: "border-box",
                                  margin: "0px 0px 16px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 500,
                                  whiteSpace: "pre-line",
                                }}
                              >
                                Si vous avez acheté un billet 100% flexible, il
                                est très facile de l'annuler ou de l'échanger.
                                Sur l'application SNCF Connect : connectez vous
                                sur votre compte puis allez dans mes voyages. o
                                Pour annuler : Cliquez sur annuler mon voyage.
                                Vous serez dirigez vers un devis d'annulation,
                                puis il faut cliquer sur confirmer l'annulation.
                                o Pour échanger : Dans mes voyages, cliquez sur
                                ''échanger mon billet''. Pas de panique, votre
                                billet initial n'est annulé que lorsque vous
                                réservez et confirmez votre nouveau billet à la
                                fin. Cliquez sur annuler et suivez les étapes
                                jusqu'à ce que vous recherchiez un nouveau
                                trajet à la même date. Sélectionnez ce trajet,
                                puis cliquez sur ''choisir ce trajet''. Suivez
                                les étapes jusqu'à la confirmation. Vous pouvez
                                réaliser les mêmes opérations sur le site SNCF
                                Connect .
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr
                    aria-hidden="true"
                    style={{
                      boxSizing: "content-box",
                      height: "1px",
                      overflow: "visible",
                      margin: "0px",
                      flexShrink: 0,
                      borderWidth: "0px 0px 1px",
                      borderStyle: "solid",
                      borderColor: "rgb(132, 139, 155)",
                    }}
                  />
                </li>
                <li style={{ boxSizing: "border-box" }}>
                  <div
                    
                    
                    
                    data-test="description_question_8"
                    style={{
                      boxSizing: "border-box",
                      borderBottomLeftRadius: "14px",
                      borderBottomRightRadius: "14px",
                      borderTopLeftRadius: "14px",
                      borderTopRightRadius: "14px",
                      color: "rgb(12, 19, 31)",
                      boxShadow: "none",
                      position: "relative",
                      transition:
                        "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                      overflowAnchor: "none",
                      borderRadius: "14px",
                      background:
                        "rgb(243, 243, 248) none repeat scroll 0% 0% / auto padding-box border-box",
                    }}
                  >
                    <div
                      tabIndex={0}
                      role="button"
                      aria-expanded="false"
                      
                      aria-controls="description_question_8-content"
                      data-test="description_question_8_summary"
                      style={{
                        boxSizing: "border-box",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        WebkitBoxPack: "center",
                        justifyContent: "center",
                        position: "relative",
                        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        outline: "rgb(12, 19, 31) none 0px",
                        border: "0px none rgb(12, 19, 31)",
                        margin: "0px",
                        borderRadius: "0px",
                        cursor: "pointer",
                        userSelect: "none",
                        verticalAlign: "middle",
                        appearance: "none",
                        textDecoration: "none solid rgb(12, 19, 31)",
                        color: "rgb(12, 19, 31)",
                        display: "flex",
                        transition:
                          "min-height 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s, background-color 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                        minHeight: "56px",
                        padding: "16px 0px",
                      }}
                    >
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          WebkitBoxFlex: 1,
                          flexGrow: 1,
                          transition:
                            "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                          margin: "0px",
                        }}
                      >
                        <div
                          style={{
                            boxSizing: "border-box",
                            WebkitBoxAlign: "center",
                            alignItems: "center",
                            display: "flex",
                            WebkitBoxFlex: 1,
                            flexGrow: 1,
                            width: "calc(100% - 34px)",
                          }}
                        >
                          <p
                            style={{
                              fontSize: "16px",
                              lineHeight: "22px",
                              boxSizing: "border-box",
                              margin: "0px",
                              fontFamily:
                                "Avenir",
                              fontWeight: 500,
                            }}
                          >
                            A qui s'adresse la Carte Liberté ?
                          </p>
                        </div>
                      </div>
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          color: "rgb(12, 19, 31)",
                          transform: "matrix(1, 0, 0, 1, 0, 0)",
                          transition:
                            "transform 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                          marginRight: "-16px",
                          padding: "0px 16px",
                        }}
                      >
                        <svg
                          aria-hidden="true"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{
                            boxSizing: "border-box",
                            height: "24px",
                            width: "1.5rem",
                            color: "rgb(20, 112, 138)",
                            display: "block",
                            fill: "rgb(20, 112, 138)",
                            flexShrink: 0,
                            fontSize: "24px",
                            transition:
                              "fill 0.2s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                            userSelect: "none",
                          }}
                        >
                          <path
                            d="M17.3341 8.79362C16.9383 8.36568 16.2617 8.36568 15.8659 8.79362L12 12.973L8.1341 8.79362C7.73825 8.36568 7.06175 8.36568 6.6659 8.79362L6.62811 8.83447C6.27358 9.21775 6.27358 9.80928 6.62811 10.1926L11.2659 15.2064C11.6617 15.6343 12.3383 15.6343 12.7341 15.2064L17.3719 10.1926C17.7264 9.80928 17.7264 9.21775 17.3719 8.83447L17.3341 8.79362Z"
                            style={{ boxSizing: "border-box" }}
                          ></path>
                        </svg>
                      </div>
                    </div>
                    <div
                      style={{
                        minHeight: "0px",
                        boxSizing: "border-box",
                        height: "0px",
                        overflow: "hidden",
                        transition:
                          "height 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                        visibility: "hidden",
                      }}
                    >
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          width: "100%",
                        }}
                      >
                        <div style={{ boxSizing: "border-box", width: "100%" }}>
                          <div
                            aria-labelledby="description_question_8-summary"
                            role="region"
                            style={{ boxSizing: "border-box" }}
                          >
                            <div
                              
                              
                              
                              data-test="description_question_8_details"
                              style={{
                                boxSizing: "border-box",
                                padding: "0px",
                                flexDirection: "column",
                              }}
                            >
                              <p
                                
                                data-test="description_details_content_8"
                                style={{
                                  fontSize: "16px",
                                  lineHeight: "22px",
                                  boxSizing: "border-box",
                                  margin: "0px 0px 16px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 500,
                                  whiteSpace: "pre-line",
                                }}
                              >
                                La Carte Liberté s'adresse à tous les voyageurs
                                fréquents qui font plus de 4 allers/retours par
                                an. Elle procure des réductions exclusives qui
                                permettent de réaliser de vraies économies pour
                                ceux qui voyagent souvent. Elle s'adresse
                                particulièrement bien aux professionnels.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr
                    aria-hidden="true"
                    style={{
                      boxSizing: "content-box",
                      height: "1px",
                      overflow: "visible",
                      margin: "0px",
                      flexShrink: 0,
                      borderWidth: "0px 0px 1px",
                      borderStyle: "solid",
                      borderColor: "rgb(132, 139, 155)",
                    }}
                  />
                </li>
                <li style={{ boxSizing: "border-box" }}>
                  <div
                    
                    
                    
                    data-test="description_question_9"
                    style={{
                      boxSizing: "border-box",
                      borderBottomLeftRadius: "14px",
                      borderBottomRightRadius: "14px",
                      borderTopLeftRadius: "14px",
                      borderTopRightRadius: "14px",
                      color: "rgb(12, 19, 31)",
                      boxShadow: "none",
                      position: "relative",
                      transition:
                        "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                      overflowAnchor: "none",
                      borderRadius: "14px",
                      background:
                        "rgb(243, 243, 248) none repeat scroll 0% 0% / auto padding-box border-box",
                    }}
                  >
                    <div
                      tabIndex={0}
                      role="button"
                      aria-expanded="false"
                      
                      aria-controls="description_question_9-content"
                      data-test="description_question_9_summary"
                      style={{
                        boxSizing: "border-box",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        WebkitBoxPack: "center",
                        justifyContent: "center",
                        position: "relative",
                        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        outline: "rgb(12, 19, 31) none 0px",
                        border: "0px none rgb(12, 19, 31)",
                        margin: "0px",
                        borderRadius: "0px",
                        cursor: "pointer",
                        userSelect: "none",
                        verticalAlign: "middle",
                        appearance: "none",
                        textDecoration: "none solid rgb(12, 19, 31)",
                        color: "rgb(12, 19, 31)",
                        display: "flex",
                        transition:
                          "min-height 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s, background-color 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                        minHeight: "56px",
                        padding: "16px 0px",
                      }}
                    >
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          WebkitBoxFlex: 1,
                          flexGrow: 1,
                          transition:
                            "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                          margin: "0px",
                        }}
                      >
                        <div
                          style={{
                            boxSizing: "border-box",
                            WebkitBoxAlign: "center",
                            alignItems: "center",
                            display: "flex",
                            WebkitBoxFlex: 1,
                            flexGrow: 1,
                            width: "calc(100% - 34px)",
                          }}
                        >
                          <p
                            style={{
                              fontSize: "16px",
                              lineHeight: "22px",
                              boxSizing: "border-box",
                              margin: "0px",
                              fontFamily:
                                "Avenir",
                              fontWeight: 500,
                            }}
                          >
                            Comment dématérialiser ma carte ?
                          </p>
                        </div>
                      </div>
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          color: "rgb(12, 19, 31)",
                          transform: "matrix(1, 0, 0, 1, 0, 0)",
                          transition:
                            "transform 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                          marginRight: "-16px",
                          padding: "0px 16px",
                        }}
                      >
                        <svg
                          aria-hidden="true"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{
                            boxSizing: "border-box",
                            height: "24px",
                            width: "1.5rem",
                            color: "rgb(20, 112, 138)",
                            display: "block",
                            fill: "rgb(20, 112, 138)",
                            flexShrink: 0,
                            fontSize: "24px",
                            transition:
                              "fill 0.2s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                            userSelect: "none",
                          }}
                        >
                          <path
                            d="M17.3341 8.79362C16.9383 8.36568 16.2617 8.36568 15.8659 8.79362L12 12.973L8.1341 8.79362C7.73825 8.36568 7.06175 8.36568 6.6659 8.79362L6.62811 8.83447C6.27358 9.21775 6.27358 9.80928 6.62811 10.1926L11.2659 15.2064C11.6617 15.6343 12.3383 15.6343 12.7341 15.2064L17.3719 10.1926C17.7264 9.80928 17.7264 9.21775 17.3719 8.83447L17.3341 8.79362Z"
                            style={{ boxSizing: "border-box" }}
                          ></path>
                        </svg>
                      </div>
                    </div>
                    <div
                      style={{
                        minHeight: "0px",
                        boxSizing: "border-box",
                        height: "0px",
                        overflow: "hidden",
                        transition:
                          "height 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                        visibility: "hidden",
                      }}
                    >
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          width: "100%",
                        }}
                      >
                        <div style={{ boxSizing: "border-box", width: "100%" }}>
                          <div
                            aria-labelledby="description_question_9-summary"
                            role="region"
                            style={{ boxSizing: "border-box" }}
                          >
                            <div
                              
                              
                              
                              data-test="description_question_9_details"
                              style={{
                                boxSizing: "border-box",
                                padding: "0px",
                                flexDirection: "column",
                              }}
                            >
                              <p
                                
                                data-test="description_details_content_9"
                                style={{
                                  fontSize: "16px",
                                  lineHeight: "22px",
                                  boxSizing: "border-box",
                                  margin: "0px 0px 16px",
                                  fontFamily:
                                    "Avenir",
                                  fontWeight: 500,
                                  whiteSpace: "pre-line",
                                }}
                              >
                                Il est désormais possible de la dématérialiser
                                sur votre mobile pour voyager en toute sérénité
                                ! Plus besoin de justificatif papier, votre
                                smartphone suffit. Pour cela suivez les
                                instructions de cette page :
                                https://www.sncf-connect.com/train/carte-abonnement-train/dematerialisation-cartes
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <hr
              aria-hidden="true"
              style={{
                boxSizing: "content-box",
                height: "8px",
                overflow: "visible",
                margin: "0px",
                flexShrink: 0,
                borderWidth: "0px",
                borderColor: "rgb(173, 255, 47)",
                backgroundColor: "rgb(255, 255, 255)",
                borderStyle: "none",
              }}
            />
            <div
              style={{
                padding: "56px 80px 0px",
                boxSizing: "border-box",
                paddingTop: "56px",
              }}
            >
              <h2
                style={{
                  fontSize: "20px",
                  lineHeight: "26px",
                  boxSizing: "border-box",
                  margin: "0px 0px 16px",
                  fontFamily: "Avenir",
                  fontWeight: 800,
                }}
              >
                Mentions légales
              </h2>
              <div
                style={{
                  boxSizing: "border-box",
                  display: "flex",
                  flexDirection: "column",
                  listStyle: "outside none none",
                  margin: "0px",
                  padding: "0px",
                }}
              >
                <div style={{ boxSizing: "border-box", marginBottom: "16px" }}>
                  <h3
                    style={{
                      fontSize: "16px",
                      lineHeight: "22px",
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontWeight: 500,
                    }}
                  >
                    *Carte Liberté :
                  </h3>
                  <p
                    style={{
                      fontSize: "13px",
                      lineHeight: "18px",
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontWeight: 500,
                      whiteSpace: "pre-line",
                    }}
                  >
                    PRIX DE LA CARTE LIBERTÉ : 19,95 € TTC Prix en vigueur du
                    29/02/2024 au 31/12/2024, hors promotion et hors code FCE.
                    Carte de réduction en vente en gares et boutiques SNCF,
                    auprès des agences de voyage agréées SNCF, par téléphone au
                    3635 (service gratuit + prix d’un appel) et sur
                    SNCF-Connect.com. Offre non cumulable avec toute autre
                    promotion en cours et bonus de renouvellement de carte.
                    Achat et utilisation de la carte soumise à autorisation
                    parentale pour tous les titulaires mineurs. SNCF Voyageurs,
                    SA au capital social de 157 789 960 euros, inscrite au RCS
                    de Bobigny sous le numéro 519 037 584 - 4, rue André Campra
                    – CS 20012 - 93212 Saint-Denis Cedex PRIX DE LA CARTE
                    LIBERTÉ : 299€ TTC Prix en vigueur du 29/02/2024 au
                    31/12/2024, hors promotion et remise négociée et avec un
                    code FCE valide. Carte de réduction en vente en gares et
                    boutiques SNCF, auprès des agences de voyage agréées SNCF et
                    sur SNCF-Connect.com. Offre non cumulable avec toute autre
                    promotion en cours et bonus de renouvellement de carte.
                    Achat et utilisation de la carte soumise à autorisation
                    parentale pour tous les titulaires mineurs. L’obtention d’un
                    code FCE est possible en remplissant le formulaire Contrat
                    Pro avec un numéro de SIRET et un code NAF valides sur
                    SNCF.com. SNCF Voyageurs, SA au capital social de 157 789
                    960 euros, inscrite au RCS de Bobigny sous le numéro 519 037
                    584 - 4, rue André Campra – CS 20012 - 93212 Saint-Denis
                    Cedex. PARTICULARITÉS LIÉES À LA CARTE : 2 TARIFS Les 2
                    tarifs offerts par la Carte Liberté ; Liberté et Avantage,
                    ne sont pas cumulables pour une même réservation. L’encarté
                    ne peut faire profiter ses&nbsp;accompagnateurs (adulte et
                    enfant(s)) des bénéfices du tarif Avantage s’il choisit le
                    tarif Liberté.En cas de voyage aller-retour sur une même
                    réservation, le tarif doit être strictement identique à
                    l’aller et au retour. CARTE RENTABILISÉE À PARTIR DE&nbsp; 3
                    ALLERS-RETOURS - PRIX CARTE 19,95 € :&nbsp;​ Amortissement
                    constaté sur 10 destinations Liberté au départ de Paris
                    (Nantes, Rennes, Bordeaux, Strasbourg, Lille, Lyon,
                    Grenoble, Marseille, Aix-en-Provence TGV et Avignon TGV), à
                    raison de 50% de voyages en 2de et 50% de voyages en 1ère
                    classe. Amortissement constaté sur la base de la différence
                    de prix entre le tarif Liberté 2de (tarif disponible
                    uniquement avec un code FCE) et de la différence entre le
                    tarif Liberté et le tarif Flex Première ou Business Première
                    sur 8 trajets cumulés. Tarifs en vigueur au 29/02/2024, prix
                    de la carte en vigueur du 29/02/2024 au 31/12/2024.
                  </p>
                </div>
                <div style={{ boxSizing: "border-box", marginBottom: "16px" }}>
                  <h3
                    style={{
                      fontSize: "16px",
                      lineHeight: "22px",
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontWeight: 500,
                    }}
                  >
                    ÉCHANGE ET REMBOURSEMENT D’UN BILLET AU TARIF LIBERTÉ
                  </h3>
                  <p
                    style={{
                      fontSize: "13px",
                      lineHeight: "18px",
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontWeight: 500,
                      whiteSpace: "pre-line",
                    }}
                  >
                    Billet remboursable sans frais jusqu’à 30 minutes après le
                    départ. À partir de 30 minutes avant départ, 1 seul échange
                    possible. Les billets échangés à partir de 30&nbsp;minutes
                    avant le départ sont non remboursables. Le billet n’est ni
                    échangeable, ni remboursable après 30 minutes après le
                    départ.&nbsp;
                  </p>
                </div>
                <div style={{ boxSizing: "border-box", marginBottom: "16px" }}>
                  <h3
                    style={{
                      fontSize: "16px",
                      lineHeight: "22px",
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontWeight: 500,
                    }}
                  >
                    LE TARIF LIBERTÉ DE LA CARTE LIBERTÉ PERMET DE BÉNÉFICIER
                    D’UNE RÉDUCTION DE 45% EN PREMIÈRE CLASSE ET DE 60%
                    EN&nbsp;SECONDE CLASSE POUR LE TITULAIRE
                  </h3>
                  <p
                    style={{
                      fontSize: "13px",
                      lineHeight: "18px",
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontWeight: 500,
                      whiteSpace: "pre-line",
                    }}
                  >
                    Offre réservée aux titulaires de la carte
                    Liberté.&nbsp;Réductions de 45% en 1re classe et de 60% en
                    2de classe réservées au titulaire de la Carte Liberté. Tarif
                    fixe et&nbsp;unique correspondant à une réduction calculée,
                    hors prestation&nbsp;supplémentaire payante, sur le tarif
                    Flex Première ou Business Première sur les trains à
                    réservation obligatoire de TGV INOUI et INTERCITÉS (hors
                    OUIGO). Sur les&nbsp;trains INTERCITÉS sans réservation
                    obligatoire la réduction est de 50% calculée sur le tarif
                    normal de la classe empruntée. Réductions applicables sur le
                    territoire&nbsp;national. Les conditions d’application sur
                    TER sont de la responsabilité des autorités organisatrices
                    et sont disponibles sur les sites Internet TER
                  </p>
                </div>
                <div style={{ boxSizing: "border-box", marginBottom: "16px" }}>
                  <h3
                    style={{
                      fontSize: "16px",
                      lineHeight: "22px",
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontWeight: 500,
                    }}
                  >
                    ECHANGE GARANTI ET CONDITIONS D’ÉCHANGE ET DE REMBOURSEMENT
                    D’UN BILLET ACHETÉ SOUS LE TARIF LIBERTÉ DE LA CARTE LIBERTÉ
                    SUR LES TRAINS TGV&nbsp;INOUI ET INTERCITÉS À RÉSERVATION
                    OBLIGATOIRE
                  </h3>
                  <p
                    style={{
                      fontSize: "13px",
                      lineHeight: "18px",
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontWeight: 500,
                      whiteSpace: "pre-line",
                    }}
                  >
                    Le service Echange Garanti est valable pour tout échange
                    effectué le jour du départ. L’échange est possible pour un
                    autre train du jour, sur le même trajet que le
                    trajet&nbsp;initial. Il est possible d’obtenir un billet sur
                    des trains complets, mais sans garantie de place assise et
                    dans la limite du nombre maximum de places debout
                    disponible.&nbsp;Le voyageur peut se voir refuser l’Echange
                    Garanti sur train complet, notamment en cas de surcharge
                    mettant en péril la sécurité des voyageurs. Dès 30 minutes
                    avant&nbsp;le départ du train initial, le nombre d’échange
                    est limité à 1 par client. Echange sans frais jusqu’à 30
                    minutes après le départ. Les billets ne sont ni échangeables
                    ni&nbsp;remboursables à partir de 30 minutes après le
                    départ.&nbsp;
                  </p>
                </div>
                <div style={{ boxSizing: "border-box", marginBottom: "16px" }}>
                  <h3
                    style={{
                      fontSize: "16px",
                      lineHeight: "22px",
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontWeight: 500,
                    }}
                  >
                    BÉNÉFICES ADDITIONNELS AVEC LE TARIF LIBERTÉ DE LA CARTE
                    LIBERTÉ
                  </h3>
                  <p
                    style={{
                      fontSize: "13px",
                      lineHeight: "18px",
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontWeight: 500,
                      whiteSpace: "pre-line",
                    }}
                  >
                    Services réservés aux clients munis d’un billet Flex
                    Première ou Business Première, Liberté 1re, les tarifs
                    négociés 1re et remisés 1re. Accès Express, Salons Grand
                    Voyageur TGV INOUI, Portail TGV INOUI. Pour les détenteurs
                    d’un billet Business Première service offre à quai
                    disponibles sur certains&nbsp;TGV INOUI et à certains
                    horaires sur les lignes et gares concernées et espace calme
                    dédié. Accès Express à l’embarquement est disponible tous
                    les jours, sur tous les trains TGV INOUI à Paris Gare de
                    Lyon, Paris Montparnasse, Paris Nord,
                    Paris&nbsp;Est,&nbsp;Nantes, Bordeaux, Rennes, Lille
                    Flandres, Lyon Part-Dieu, Lyon Perrache, Marseille,
                    Montpellier Sud de France. Accès Express en espaces de vente
                    est disponible tous les jours, selon les horaires
                    d’ouvertures du point de vente à Paris Gare de Lyon, Paris
                    Montparnasse,&nbsp;Paris&nbsp;Nord, Paris Est, Nantes,
                    Bordeaux, Rennes, Lille Flandres, Lille Europe, Strasbourg,
                    Lyon Part-Dieu, Marseille, Grenoble, aéroport CDG 2. L’Accès
                    aux 12 Salons Grand Voyageur TGV INOUI est garanti tous les
                    jours du lundi au dimanche, selon les horaires d’ouverture
                    du Salon. L’offre à quai est disponible en semaine aux
                    heures de pointe (matin et fin d’après-midi) sur les trains
                    TGV INOUI entre Paris et Nantes, Bordeaux,
                    Rennes,&nbsp;Lille&nbsp;Flandres, Strasbourg, Lyon
                    Part-Dieu, Lyon Perrache, Marseille, Montpellier Saint Roch.
                  </p>
                </div>
                <div style={{ boxSizing: "border-box", marginBottom: "16px" }}>
                  <h3
                    style={{
                      fontSize: "16px",
                      lineHeight: "22px",
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontWeight: 500,
                    }}
                  >
                    LE TARIF LIBERTÉ DE LA CARTE LIBERTÉ PERMET DE BÉNÉFICIER DE
                    15% DE RÉDUCTION SUR CERTAINS SERVICES
                  </h3>
                  <p
                    style={{
                      fontSize: "13px",
                      lineHeight: "18px",
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontWeight: 500,
                      whiteSpace: "pre-line",
                    }}
                  >
                    La Carte Liberté avec le tarif Liberté permet une réduction
                    de 15% de réduction sur les services le&nbsp;BAR TGV INOUI,
                    Mes Bagages,&nbsp;Mon Chauffeur, Ma Location Avis et Junior
                    &amp; Cie. Offres soumises à&nbsp;conditions. Informations
                    sur les services disponibles sur sncf-voyageurs.com.&nbsp;
                    -15% sur Ma Location Avis : Les détenteurs d’une carte
                    Liberté bénéficient de 15% de réduction. Offre soumise à
                    conditions, valable sur les tarifs prépayés AVIS et BUDGET
                    France grand public, pour des départs en&nbsp;France
                    continentale (hors Corse), pour toutes locations de 1 à 30
                    jours. Remise accessible pour un paiement à la réservation
                    pour toute catégorie de véhicule hors AVIS Prestige, AVIS
                    Select Séries&nbsp;et les véhicules utilitaires AVIS. Les
                    remises sont calculées sur un prix AVIS ou BUDGET hors
                    surcharge, hors complément de protection et hors assurance.
                    Offre valable sous réserve de disponibilité&nbsp;des
                    véhicules au moment de la location. Plus d'informations
                    sur&nbsp;https://secure.malocationavis.sncf-connect.com/
                    -15% sur mes bagages : Réduction de 15% sur la commande du
                    service Mes Bagages avec une Carte Liberté. Offre valable
                    dès le 1er bagage (hors fauteuils roulants) sur internet
                    (mesbagages.sncf-connect.com), par téléphone au 3635
                    (service gratuit + prix appel) et en gare et boutiques SNCF.
                    -15% sur la restauration à bord : 15% de réduction sur
                    toutes les formules et menus. Réduction valable sur
                    présentation de votre Carte Liberté en cours de validité
                    (sans limitation du nombre de passage au Bar) ou
                    d’un&nbsp;tarif Liberté précisé sur votre billet. Carte
                    Liberté avec un billet au tarif Liberté : réduction valable
                    pour le titulaire de la carte. Carte Liberté avec un billet
                    au tarif Avantage :&nbsp;réduction valable pour le titulaire
                    de la carte et son accompagnateur de plus de 12
                    ans.&nbsp;Pour les enfants de 4 à 11 ans accompagnateurs
                    d’un titulaire de Carte Liberté&nbsp;: offre exclusive «
                    Goûter Avantage » (Jus de pomme ou eau plate + cookie
                    ou&nbsp;M&amp;M’s® + yaourt au choix) au prix de 5€, en
                    présence de l’enfant ou sur présentation de son titre
                    de&nbsp;transport. Offre non applicable sur les
                    trains&nbsp;Renfe-SNCF en coopération,
                    TGV&nbsp;Lyria&nbsp;et TGV INOUI vers l’Italie. -15% sur
                    Junior &amp; Cie : Si le client possède une Carte Liberté,
                    il bénéficie de 15% de réduction sur le forfait, valable
                    pour un voyage de 1 à 3 enfants. Cet avantage n'est ni
                    cumulable avec l’avantage Carte&nbsp;Famille Nombreuse ni
                    avec un code promotionnel.Offre non remboursable et non
                    cumulable avec une autre offre promotionnelle. Les
                    conditions habituelles de location notamment quant à l’âge,
                    la qualification du conducteur et le paiement doivent être
                    respectées (se reporter aux brochures des Conditions
                    générales de location AVIS
                    https://www.avis.fr/conditions-generales-avis). Pour plus
                    d’informations, rdv sur :
                    https://www.sncf-connect.com/train/services-train/train-avis.
                  </p>
                </div>
                <div style={{ boxSizing: "border-box", marginBottom: "16px" }}>
                  <h3
                    style={{
                      fontSize: "16px",
                      lineHeight: "22px",
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontWeight: 500,
                    }}
                  >
                    BÉNÉFICES ADDITIONNELS AVEC LE TARIF LIBERTÉ DE LA CARTE
                    LIBERTÉ
                  </h3>
                  <p
                    style={{
                      fontSize: "13px",
                      lineHeight: "18px",
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontWeight: 500,
                      whiteSpace: "pre-line",
                    }}
                  >
                    Services réservés aux clients munis d’un billet Flex
                    Première ou Business Première, Liberté 1re, les tarifs
                    négociés 1re et remisés 1re. Accès Express, Salons Grand
                    Voyageur TGV INOUI, Portail TGV INOUI. Pour les détenteurs
                    d’un billet Business Première service offre à quai
                    disponibles sur certains TGV INOUI et à certains horaires
                    sur les lignes et gares concernées et espace calme dédié.
                    Accès Express à l’embarquement est disponible tous les
                    jours, sur tous les trains TGV INOUI à Paris Gare de Lyon,
                    Paris Montparnasse, Paris Nord, Paris Est, Nantes, Bordeaux,
                    Rennes, Lille Flandres, Lyon Part-Dieu, Lyon Perrache,
                    Marseille, Montpellier Sud de France. Accès Express en
                    espaces de vente est disponible tous les jours, selon les
                    horaires d’ouvertures du point de vente à Paris Gare de
                    Lyon, Paris Montparnasse, Paris Nord, Paris Est, Nantes,
                    Bordeaux, Rennes, Lille Flandres, Lille Europe, Strasbourg,
                    Lyon Part-Dieu, Marseille, Grenoble, aéroport CDG 2. L’Accès
                    aux 12 Salons Grand Voyageur TGV INOUI est garanti tous les
                    jours du lundi au dimanche, selon les horaires d’ouverture
                    du Salon. L’offre à quai est disponible en semaine aux
                    heures de pointe (matin et fin d’après-midi) sur les trains
                    TGV INOUI entre Paris et Nantes, Bordeaux, Rennes, Lille
                    Flandres, Strasbourg, Lyon Part-Dieu, Lyon Perrache,
                    Marseille, Montpellier Saint Roch.
                  </p>
                </div>
                <div style={{ boxSizing: "border-box", marginBottom: "16px" }}>
                  <h3
                    style={{
                      fontSize: "16px",
                      lineHeight: "22px",
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontWeight: 500,
                    }}
                  >
                    LE TARIF AVANTAGE DE LA CARTE LIBERTÉ PERMET DE BÉNÉFICIER
                    D’UNE RÉDUCTION DE 30% POUR LE TITULAIRE
                    ET&nbsp;L’ACCOMPAGNANT&nbsp;ADULTE
                  </h3>
                  <p
                    style={{
                      fontSize: "13px",
                      lineHeight: "18px",
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontWeight: 500,
                      whiteSpace: "pre-line",
                    }}
                  >
                    Réduction de 30% valable pour le titulaire et l’accompagnant
                    adulte de plus de 12 ans : - sur des trajets aller simple
                    tous les jours dès lors que le titulaire&nbsp;voyage
                    avec&nbsp;un bambin (moins de 4 ans) ou un enfant (4 à 11
                    ans inclus) - sur des trajets aller simple le samedi ou le
                    dimanche - sur des voyages aller-retour incluant au moins la
                    nuit du vendredi,&nbsp;samedi ou&nbsp;dimanche. Le délai
                    maximum entre les trajets aller et retour est de 61 jours et
                    ne peut être prolongé en cas d’échange.&nbsp; Si le bénéfice
                    du tarif Avantage est conditionné au voyage avec un enfant
                    ou bambin, ce dernier devra être présent et en possession
                    d’un titre de transport valable (billet accompagnant enfant
                    ou tarif bambin) lors du contrôle à bord du train. Un
                    accompagnant&nbsp;(adulte&nbsp;ou enfant) ayant bénéficié
                    d’une réduction associée au tarif Avantage de la carte
                    Liberté devra obligatoirement voyager avec le titulaire de
                    la carte&nbsp;Liberté&nbsp;correspondante. Offre réservée
                    aux titulaires de la Carte Liberté avec le tarif Avantage,
                    et un accompagnateur de plus de 12 ans si le billet est
                    acheté simultanément au billet&nbsp;du&nbsp;titulaire de la
                    Carte Liberté. Réduction calculée, hors prestations
                    supplémentaires payantes, sur le tarif PREM’S, 2de,
                    1re&nbsp;et le Plein Tarif 2de&nbsp;et 1re&nbsp;pour les
                    trains&nbsp;à&nbsp;réservation obligatoire (TGV INOUI et
                    INTERCITÉS, hors OUIGO) et sur le Tarif « Normal » pour les
                    trains INTERCITÉS sans réservation obligatoire dans
                    le&nbsp;cadre&nbsp;de billets valables 7 jours. Réductions
                    applicables sur le territoire national. Garantie d’un prix
                    plafonné pour le titulaire de la carte et un accompagnant
                    adulte avec le tarif Avantage, par trajet et en fonction du
                    temps moyen observé sur&nbsp;un&nbsp;trajet sans
                    correspondance. 2,45 € TTC : prix maximum garanti d’un billet
                    pour un trajet de moins de 1h30, 69€ TTC : prix maximum
                    garanti d’un billet pour un&nbsp;trajet&nbsp;de moins de 3h,
                    89€ TTC : prix maximum garanti d’un billet pour un trajet de
                    plus de 3h&nbsp;en France en seconde classe sur un trajet
                    sans correspondance. Prix&nbsp;fixe&nbsp;jusqu’au départ du
                    train.
                  </p>
                </div>
                <div style={{ boxSizing: "border-box", marginBottom: "16px" }}>
                  <h3
                    style={{
                      fontSize: "16px",
                      lineHeight: "22px",
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontWeight: 500,
                    }}
                  >
                    LE TARIF AVANTAGE DE LA CARTE LIBERTÉ PERMET DE BÉNÉFICIER
                    D’UNE RÉDUCTION DE 60% POUR LES ENFANTS ACCOMPAGNANTS
                  </h3>
                  <p
                    style={{
                      fontSize: "13px",
                      lineHeight: "18px",
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontWeight: 500,
                      whiteSpace: "pre-line",
                    }}
                  >
                    Offre réservée jusqu’à 3 accompagnateurs enfants de 4 à 11
                    ans inclus si le billet est acheté simultanément au billet
                    du titulaire de la Carte Liberté avec&nbsp;le
                    tarif&nbsp;Avantage. Réduction calculée, hors prestations
                    supplémentaires payantes, sur le tarif PREM’S, 2de,
                    1re&nbsp;et le Plein Tarif 2de&nbsp;et 1re&nbsp;pour les
                    trains à&nbsp;réservation&nbsp;obligatoire (TGV INOUI et
                    INTERCITÉS, hors OUIGO), ou sur le tarif « Normal » pour les
                    trains INTERCITÉS sans réservation obligatoire dans le
                    cadre&nbsp;de billets&nbsp;valables 7 jours. Réductions
                    applicables sur le territoire national.&nbsp;La carte
                    Liberté TGV INOUI avec le tarif Avantage permet une
                    réduction de 15% sur&nbsp;les&nbsp;services Ma Location
                    Avis, Restau à bord, Mes Bagages et Junior &amp; Cie. Offres
                    soumises à conditions. Informations sur les services
                    disponibles sur sncf.com. Si le bénéfice du tarif Avantage
                    est conditionné au voyage avec un enfant ou un bambin, ce
                    dernier devra être présent lors du contrôle à bord du train.
                    Un accompagnant (adulte ou enfant) ayant bénéficié d’une
                    réduction associée au tarif Avantage de la Carte Liberté
                    devra obligatoirement voyager avec le titulaire de la carte
                    Liberté correspondante.
                  </p>
                </div>
                <div style={{ boxSizing: "border-box", marginBottom: "16px" }}>
                  <h3
                    style={{
                      fontSize: "16px",
                      lineHeight: "22px",
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontWeight: 500,
                    }}
                  >
                    LE TARIF AVANTAGE DE LA CARTE LIBERTÉ PERMET D’ACCÉDER À DES
                    OFFRES DE DERNIÈRE MINUTE NO FLEX
                  </h3>
                  <p
                    style={{
                      fontSize: "13px",
                      lineHeight: "18px",
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontWeight: 500,
                      whiteSpace: "pre-line",
                    }}
                  >
                    Offre disponible en dernière minute accessible dans les
                    trains TGV INOUI, INTERCITÉS à réservation obligatoire et
                    INTERCITÉS. Offre réservée au titulaire de la
                    carte&nbsp;Liberté avec le tarif Avantage et à un
                    accompagnant adulte et jusqu’à 3 accompagnants enfants âgés
                    de 4 à 11 ans inclus à condition de voyager dans le
                    même&nbsp;train et la même classe. L’achat des billets NO
                    FLEX du titulaire et des accompagnants doit être simultané.
                    L’offre NO FLEX est disponible sur une sélection
                    de&nbsp;destinations en France et en Europe, certains jours
                    et dans certains trains dans la limite des places
                    disponibles. Offre non cumulable avec toute autre promotion
                    en&nbsp;cours ou tarif réduit SNCF ou Partenaires européens.
                    Offre non échangeable et non remboursable.&nbsp;
                  </p>
                </div>
                <div style={{ boxSizing: "border-box", marginBottom: "16px" }}>
                  <h3
                    style={{
                      fontSize: "16px",
                      lineHeight: "22px",
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontWeight: 500,
                    }}
                  >
                    CONDITIONS D’ÉCHANGE ET DE REMBOURSEMENT D’UN BILLET ACHETÉ
                    AU TARIF AVANTAGE DE LA CARTE LIBERTÉ SUR LES TRAINS
                    TGV&nbsp;INOUI ET INTERCITÉS À RÉSERVATION OBLIGATOIRE
                  </h3>
                  <p
                    style={{
                      fontSize: "13px",
                      lineHeight: "18px",
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontWeight: 500,
                      whiteSpace: "pre-line",
                    }}
                  >
                    Service d’échange et de remboursement proposé gratuitement
                    jusqu’à 7 jours inclus avant départ. Dès 6 jours, avant le
                    départ, retenue de 19€ par personne et par trajet appliquée
                    sur TGV INOUI et de 40% du prix du billet avec retenue
                    maximum de 15€ sur INTERCITÉS à réservation obligatoire. 30
                    min avant départ et jusqu’au départ, échange possible (1
                    maximum) avec la même retenue qu’énoncée précédemment. Les
                    billets échangés dans ce laps de temps sont non
                    remboursables. La retenue n’est appliquée qu’une fois, pour
                    les trajets comprenant une ou plusieurs correspondances.
                    Billet non échangeable et non remboursable après le départ
                    du train, sauf si celui-ci a été remis à disposition avant
                    départ. &nbsp; CONDITIONS SPÉCIFIQUES DANS LE CADRE D’UN
                    ÉCHANGE OU D’UNE ANNULATION DE BILLETS ALLER/RETOUR CARTE
                    AVANTAGE ADULTE. 1. Réservation initiale éligible à la
                    réduction Avantage Adulte : Si l’échange d’un des deux
                    trajets entraîne la perte de cette condition de la réduction
                    de la Carte Avantage Adulte ; le billet échangé est retaxé
                    au tarif du jour de l’échange. Le billet inchangé
                    (correspondant à un trajet futur ou déjà réalisé) est
                    refacturé au tarif sans réduction du jour de l’achat initial
                    des billets. Si l’annulation d’un des deux trajets entraîne
                    la perte de cette condition de la réduction de la carte
                    Avantage Adulte, le billet annulé est remboursé. Le billet
                    inchangé (correspondant à un trajet futur ou déjà réalisé)
                    est refacturé au tarif sans réduction du jour de l’achat
                    initial des billets et déduit du montant total à rembourser.
                    Si le montant refacturé dépasse le remboursement, aucune
                    action ne sera réalisée. 2. Réservation initiale non
                    éligible à la réduction Avantage Adulte : Si l’échange d’un
                    aller-retour permet l’éligibilité à la réduction de la carte
                    Avantage Adulte ; le billet échangé (aller ou retour)
                    bénéficie alors de la réduction Avantage. Le billet inchangé
                    (correspondant à un trajet futur ou déjà réalisé) ne
                    bénéficie pas de la réduction Avantage.
                  </p>
                </div>
                <div style={{ boxSizing: "border-box", marginBottom: "16px" }}>
                  <h3
                    style={{
                      fontSize: "16px",
                      lineHeight: "22px",
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontWeight: 500,
                    }}
                  >
                    LE TARIF LIBERTÉ DE LA CARTE LIBERTÉ PERMET DE BÉNÉFICIER
                    D’UNE RÉDUCTION EN EUROPE
                  </h3>
                  <p
                    style={{
                      fontSize: "13px",
                      lineHeight: "18px",
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontWeight: 500,
                      whiteSpace: "pre-line",
                    }}
                  >
                    Offre réservée aux titulaires de la Carte Liberté. Réduction
                    calculée pour le tarif Avantage, hors prestations
                    supplémentaires payantes, sur le tarif 2de ou 1re du jour
                    sur&nbsp;les trains TGV INOUI à destination du Luxembourg,
                    l'Italie, l'Espagne, sur les trains TGV INOUI et ICE de
                    DB-SNCF en coopération vers Fribourg-en-Brisgau, sur le
                    tarif Standard ou&nbsp;Standard 1re des trains
                    TGV&nbsp;Lyria. Offre réservée aux titulaires de la carte
                    Liberté.&nbsp;Réduction calculée pour le tarif Liberté, hors
                    prestations&nbsp;supplémentaires payantes, sur le tarif Flex
                    Première ou Business Première sur les trains TGV INOUI à
                    destination du Luxembourg, l'Italie, l'Espagne, sur les
                    trains TGV INOUI et ICE de DB-SNCF en coopération vers
                    Fribourg-en-Brisgau.&nbsp;Sur les trains TGV&nbsp;Lyria, la
                    réduction est de 40% minimum en&nbsp;Business Première sur
                    le tarif Business Première et de 60% en classe Standard
                    calculée sur le tarif Standard Première Flex. Les réductions
                    appliquées peuvent être&nbsp;différentes selon le
                    transporteur. Les informations sur les réductions appliquées
                    sont disponibles sur les sites web de chaque transporteur.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
